<template>
  <div>
    <b-tabs content-class="mt-3" v-model="tab_index">
      <b-tab
        :title="
          $getVisibleNames('mesh.egressprofilematter', false, 'Asignatura')
        "
      >
        <div>
          <!-- Banner para seleccionar Asignatura Base al crear -->
          <div
            v-if="
              isNaN(old_matter.id) && !old_matter.is_closed && !matter.matter
            "
            class="mb-3"
          >
            <b-alert show variant="info">
              <div class="select-base-matter-banner-content">
                <div>
                  <b-icon icon="clipboard-check" font-scale="1.5"></b-icon>
                </div>
                <div class="select-base-matter-banner-text">
                  <strong>
                    {{
                      $t("matterProgram.matterForm.selectEntity", {
                        entity: $getVisibleNames(
                          "teaching.matter",
                          false,
                          "Asignatura Base"
                        ),
                      })
                    }}
                  </strong>
                  <span class="select-base-matter-banner-desc">
                    {{
                      $t("matterProgram.matterForm.selectBaseDescription", {
                        entity: $getVisibleNames(
                          "teaching.matter",
                          false,
                          "Asignatura Base"
                        ),
                      })
                    }}
                  </span>
                </div>
                <b-button
                  class=""
                  @click="$bvModal.show('bv-modal-matter-select')"
                  variant="primary"
                  size="sm"
                >
                  <b-icon icon="clipboard-check" class="mr-1"></b-icon>
                  {{
                    $t("matterProgram.matterForm.selectEntity", {
                      entity: $getVisibleNames(
                        "teaching.matter",
                        false,
                        "Asignatura Base"
                      ),
                    })
                  }}
                </b-button>
              </div>
            </b-alert>
          </div>
          <b-form-group
            label-for="name-input"
            label-cols="1"
            label-cols-sm="3"
            class="label m-0"
            label-class="label-matter"
          >
            <template #label>
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(institution && institution.internal_use_id == 'duoc.cl')
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️</span
              >{{ $t("reusable.common.name") }}
            </template>
            <div class="d-flex align-items-start">
              <div class="d-block w-100">
                <!-- && isNaN(old_matter.id) -->
                <b-form-input
                  id="name-input"
                  v-model="$v.old_matter.name.$model"
                  :disabled="old_matter.is_closed"
                  v-bind:class="{
                    'matter-name': !SameMatterName,
                  }"
                  :state="validateOldMatter('name')"
                  aria-describedby="input-name-feedback"
                  size="sm"
                  @update="
                    (value) => {
                      old_matter.name = value.toUpperCase();
                    }
                  "
                >
                </b-form-input>
                <!-- :disabled="!isNaN(old_matter.id)" -->
                <b-form-invalid-feedback
                  id="input-name-feedback"
                  class="mt-0 mb-1"
                >
                  <span v-if="old_matter.name.length <= 1">
                    {{
                      $t("matterProgram.matterForm.fieldMinLength", { min: 1 })
                    }}
                  </span>
                  <span v-if="!SameEgressProfileMatterName">
                    {{
                      $t("matterProgram.matterForm.existsWithName", {
                        entity: $getVisibleNames(
                          "mesh.egressprofilematter",
                          false,
                          "Asignatura"
                        ),
                        context: $getVisibleNames(
                          "mesh.egressprofile",
                          false,
                          "Perfil de Egreso"
                        ),
                      })
                    }}
                  </span>
                  <span v-if="show_err_trasnversal_matter">
                    {{
                      $t(
                        "matterProgram.matterForm.cannotCreateBelongsToOther",
                        {
                          entity: $getVisibleNames(
                            "mesh.egressprofilematter",
                            false,
                            "Asignatura"
                          ),
                          context: $getVisibleNames(
                            "mesh.faculty",
                            false,
                            "Facultad"
                          ),
                        }
                      )
                    }}
                  </span>
                </b-form-invalid-feedback>
                <!-- && isNaN(old_matter.id) -->
                <span v-if="!SameMatterName" class="text-info">
                  {{
                    $t("matterProgram.matterForm.existsWithSameName", {
                      entity: $getVisibleNames(
                        "teaching.matter",
                        false,
                        "Asignatura Base"
                      ),
                    })
                  }}
                </span>
              </div>
              <div class="d-flex">
                <b-button
                  class="btn-name-matter ml-2"
                  v-if="!old_matter.is_closed"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('matterProgram.matterForm.selectEntity', {
                      entity: $getVisibleNames(
                        'teaching.matter',
                        false,
                        'Asignatura Base'
                      ),
                    })
                  "
                  @click="$bvModal.show('bv-modal-matter-select')"
                >
                  <b-icon font-scale="1" icon="clipboard-check"></b-icon>
                </b-button>
                <b-button
                  class="btn-name-matter ml-2"
                  v-if="!old_matter.is_closed"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('matterProgram.matterForm.clearNameAndEntity', {
                      entity: $getVisibleNames(
                        'manual.matter_code',
                        false,
                        'Código'
                      ),
                    })
                  "
                  @click="resetOldMatter"
                >
                  <b-icon font-scale="1" icon="x-square"></b-icon>
                </b-button>
              </div>
            </div>
          </b-form-group>
          <b-modal size="xl" id="bv-modal-matter-select" hide-footer>
            <template #modal-title>
              {{
                $t("matterProgram.matterForm.selectToUse", {
                  entity: $getVisibleNames(
                    "mesh.egressprofilematter",
                    false,
                    "Asignatura"
                  ),
                })
              }}
            </template>
            <b-alert show variant="info" class="small mb-3">
              <div class="font-weight-bold mb-1">
                <b-icon icon="info-circle-fill" class="mr-1"></b-icon>
                {{
                  $t("matterProgram.matterForm.preservedDataTitle", {
                    entity: $getVisibleNames(
                      "teaching.matter",
                      false,
                      "Asignatura Base"
                    ),
                  })
                }}
              </div>
              <span>
                {{
                  $t("matterProgram.matterForm.preservedDataDesc", {
                    entity: $getVisibleNames(
                      "teaching.matter",
                      false,
                      "Asignatura Base"
                    ),
                  })
                }}
                <strong>{{ preservedItemsJoined }}</strong
                >.
              </span>
            </b-alert>
            <div class="d-block text-center">
              <NewGenericBTable
                :fields="fieldsMatterCode"
                :show_pagination="true"
                :search_filter="true"
                :columns_display="false"
                url="/teaching/alt-matter/"
              >
                <template #cell(selected)="row">
                  <b-checkbox
                    :checked="old_matter.id == row.item.id"
                    @change="ChangeOldMatter(row.item.id)"
                  ></b-checkbox>
                </template>
                <template #cell(modalities)="row">
                  <div class="text-left">
                    <span
                      v-for="(modality, index) in row.item.modalities"
                      :key="row.item.id + ',' + index"
                    >
                      {{ getModality(modality) }}
                      <span v-if="index + 1 != row.item.modalities.length"
                        >-</span
                      >
                    </span>
                  </div>
                </template>
                <template #cell(formation_area)="row">
                  {{ getFormationArea(row.item.formation_area) }}
                </template>
              </NewGenericBTable>
            </div>
          </b-modal>
          <!-- Modal de confirmación para importar datos de Asignatura Base por código -->
          <b-modal
            id="bv-modal-import-base-matter"
            centered
            size="lg"
            @ok="confirmImportBaseMatter"
          >
            <template #modal-title>
              <b-icon
                icon="exclamation-triangle-fill"
                variant="warning"
                class="mr-2"
              ></b-icon>
              {{
                $t("matterProgram.matterForm.importFromBaseByCodeTitle", {
                  code_entity: $getVisibleNames(
                    "manual.matter_code",
                    false,
                    "Código"
                  ),
                })
              }}
            </template>
            <RenderVHtml
              class="p-0 mb-3"
              :content="
                $t('matterProgram.matterForm.importFromBaseByCode', {
                  entity: $getVisibleNames(
                    'teaching.matter',
                    false,
                    'Asignatura Base'
                  ),
                  code_entity: $getVisibleNames(
                    'manual.matter_code',
                    false,
                    'Código'
                  ),
                  name: found_matter_name_by_code,
                })
              "
            ></RenderVHtml>
            <b-alert show variant="warning" class="small mb-0">
              <div class="font-weight-bold mb-1">
                <b-icon icon="info-circle-fill" class="mr-1"></b-icon>
                {{
                  $t("matterProgram.matterForm.preservedDataTitle", {
                    entity: $getVisibleNames(
                      "teaching.matter",
                      false,
                      "Asignatura Base"
                    ),
                  })
                }}
              </div>
              <span>
                {{
                  $t("matterProgram.matterForm.preservedDataDesc", {
                    entity: $getVisibleNames(
                      "teaching.matter",
                      false,
                      "Asignatura Base"
                    ),
                  })
                }}
                <strong>{{ preservedItemsJoined }}</strong
                >.
              </span>
            </b-alert>
            <template #modal-ok>
              {{
                $t("matterProgram.matterForm.importData", {
                  entity: $getVisibleNames(
                    "teaching.matter",
                    false,
                    "Asignatura Base"
                  ),
                })
              }}
            </template>
            <template #modal-cancel>
              {{ $t("reusable.common.cancel") }}
            </template>
          </b-modal>
          <div class="row-code mt-1 mb-2">
            <div class="w-25">
              <label for="input-code" class="label-code">
                <span
                  v-if="
                    !old_matter.is_closed &&
                    !(institution && institution.internal_use_id == 'duoc.cl')
                  "
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('matterProgram.matterForm.changesReflectedTooltip', {
                      entity: $getVisibleNames(
                        'mesh.egressprofilematter',
                        true,
                        'Asignaturas'
                      ).toLowerCase(),
                    })
                  "
                  >⚠️</span
                >
                {{
                  $getVisibleNames("manual.matter_code", false, "Código")
                }}</label
              >
            </div>
            <div class="w-75">
              <b-form-group class="label m-0 custom-input">
                <!-- :disabled="!isNaN(old_matter.id)" -->
                <div class="d-flex">
                  <div class="w-100">
                    <b-form-input
                      id="input-code"
                      v-model="$v.old_matter.code.$model"
                      :state="validateOldMatter('code')"
                      aria-describedby="input-code-live-feedback"
                      :disabled="old_matter.is_closed"
                      size="sm"
                      class="input-code mt-1"
                      @update="
                        (value) => {
                          old_matter.code = value.toUpperCase();
                        }
                      "
                      @input="
                        () => {
                          verified_code = false;
                          found_matter_id_by_code = null;
                        }
                      "
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-code-live-feedback">
                      <div
                        v-if="verified_code == false"
                        :class="{
                          'mt-2': old_matter.code.length > 0,
                        }"
                      >
                        {{
                          $t("matterProgram.matterForm.reviewCode", {
                            entity: $getVisibleNames(
                              "manual.matter_code",
                              false,
                              "Código"
                            ),
                            context: $getVisibleNames(
                              "teaching.matter",
                              false,
                              "Asignatura Base"
                            ),
                          })
                        }}.
                      </div>
                      <div
                        v-if="code_used == true && verified_code == true"
                        :class="{
                          'mt-2': old_matter.code.length > 0,
                        }"
                      >
                        {{
                          $t("matterProgram.matterForm.alreadyBeingUsed", {
                            entity: $getVisibleNames(
                              "manual.matter_code",
                              false,
                              "Código"
                            ),
                          })
                        }}
                      </div>
                    </b-form-invalid-feedback>
                  </div>
                  <b-button
                    v-if="!old_matter.is_closed"
                    @click="checkCode()"
                    class="btn-check-code ml-1"
                    v-b-tooltip.v-secondary.noninteractive="
                      `${
                        verified_code == true && code_used == false
                          ? ``
                          : verified_code == false
                          ? $t(
                              'matterProgram.matterForm.verifyEntityAvailable',
                              {
                                entity: $getVisibleNames(
                                  'manual.matter_code',
                                  false,
                                  'Código'
                                ),
                              }
                            )
                          : code_used == true
                          ? $t('matterProgram.matterForm.occupied', {
                              entity: $getVisibleNames(
                                'manual.matter_code',
                                false,
                                'Código'
                              ),
                            })
                          : ``
                      }`
                    "
                  >
                    <b-icon icon="arrow-clockwise"></b-icon
                  ></b-button>
                </div>
              </b-form-group>
            </div>
          </div>
          <b-form-group
            v-if="institution && institution.internal_use_id == 'duoc.cl'"
            label-cols="0"
            label-cols-sm="5"
            class="label m-0"
          >
            <template #label>
              <div class="weighing-label">
                <div class="label-content ml-1">
                  {{ $t("matterProgram.matterForm.isCapstoneCourse") }}
                </div>
              </div>
            </template>
            <div id="credit">
              <div class="d-flex">
                <div class="noprint">
                  <span
                    :class="{
                      'font-weight-bold': old_matter.is_capstone_course,
                    }"
                    >{{ $t("reusable.common.yes") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': old_matter.is_closed }"
                    @click="
                      () => {
                        if (!old_matter.is_closed)
                          old_matter.is_capstone_course = !old_matter.is_capstone_course;
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !old_matter.is_capstone_course,
                        'icon-check-disabled': old_matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !old_matter.is_capstone_course,
                    }"
                    >{{ $t("reusable.common.no") }}</span
                  >
                </div>
              </div>
            </div>
          </b-form-group>
          <div
            v-if="institution && institution.use_epm_code"
            class="row-code mt-1 mb-2"
          >
            <div class="w-25">
              <label for="input-epm-code" class="label-code">
                {{
                  $getVisibleNames("manual.ep_matter_code", false, "Código")
                }}
              </label>
            </div>
            <div class="w-75">
              <b-form-group class="label m-0 custom-input">
                <div class="d-flex">
                  <div class="w-100">
                    <b-form-input
                      id="input-epm-code"
                      v-model="matter.code"
                      :disabled="matter.is_closed"
                      size="sm"
                      class="input-code mt-1"
                      @update="
                        (value) => {
                          matter.code = value.toUpperCase();
                        }
                      "
                    ></b-form-input>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
          <b-form-group label-cols="0" label-cols-sm="5" class="label m-0">
            <template #label>
              <div class="weighing-label">
                <div class="label-content ml-1">
                  <span
                    v-if="
                      !old_matter.is_closed &&
                      !(institution && institution.internal_use_id == 'duoc.cl')
                    "
                    v-b-tooltip.v-secondary.noninteractive="
                      $t('matterProgram.matterForm.changesReflectedTooltip', {
                        entity: $getVisibleNames(
                          'mesh.egressprofilematter',
                          true,
                          'Asignaturas'
                        ).toLowerCase(),
                      })
                    "
                    >⚠️</span
                  >{{ $t("matterProgram.matterForm.equivalentWeighting") }}
                  <span>
                    <InfoTooltip
                      class="info-icon"
                      :tooltip_text="
                        $t(
                          'matterProgram.matterForm.useEquivalentWeightingTooltip',
                          {
                            entity1: $getVisibleNames(
                              'teaching.ramicro',
                              false,
                              'RA Micro'
                            ),
                            entity2:
                              institution && !institution.show_ra_macro
                                ? ''
                                : String(
                                    ` ${$t('reusable.common.and')} 
                                      ${$getVisibleNames(
                                        'teaching.evaluationcriteriamacro',
                                        true,
                                        'Criterios de Evaluación Macro'
                                      )}`
                                  ),
                          }
                        )
                      "
                    >
                    </InfoTooltip
                  ></span>
                </div>
              </div>
            </template>
            <div id="credit">
              <div class="d-flex align-items-center">
                <div class="pr-2 noprint">
                  <span
                    :class="{
                      'font-weight-bold':
                        old_matter.automatic_achievement_weighing,
                    }"
                    >{{ $t("reusable.common.yes") }}</span
                  >
                  <!-- :disabled="!isNaN(old_matter.id)" -->
                  <b-button
                    class="check-type"
                    :class="{
                      'check-type-disabled':
                        old_matter.is_closed || theTestsHaveSomeCorrect,
                    }"
                    @click="
                      () => {
                        if (!old_matter.is_closed && !theTestsHaveSomeCorrect)
                          old_matter.automatic_achievement_weighing =
                            !old_matter.automatic_achievement_weighing;
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active':
                          !old_matter.automatic_achievement_weighing,
                        'icon-check-disabled':
                          old_matter.is_closed || theTestsHaveSomeCorrect,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold':
                        !old_matter.automatic_achievement_weighing,
                    }"
                    >{{ $t("reusable.common.no") }}</span
                  >
                </div>
                <span
                  v-if="
                    theTestsHaveSomeCorrect &&
                    old_matter &&
                    !old_matter.is_closed
                  "
                >
                  <ButtonErrorInstrument
                    variant="danger"
                    :popover_text="
                      $t(
                        'matterProgram.matterForm.cannotChangeWeightingClosedEvaluations'
                      )
                    "
                    :id_popover="`matter-correct-${matter.id}`"
                    click_modal="new-evaluation-correct-list-modal"
                  ></ButtonErrorInstrument>
                </span>
              </div>
            </div>
          </b-form-group>
          <b-form-group label-cols="0" label-cols-sm="5" class="label m-0">
            <template #label>
              <div class="weighing-label">
                <div class="label-content ml-1">
                  <span
                    v-if="
                      !old_matter.is_closed &&
                      !(institution && institution.internal_use_id == 'duoc.cl')
                    "
                    v-b-tooltip.v-secondary.noninteractive="
                      $t('matterProgram.matterForm.changesReflectedTooltip', {
                        entity: $getVisibleNames(
                          'mesh.egressprofilematter',
                          true,
                          'Asignaturas'
                        ).toLowerCase(),
                      })
                    "
                    >⚠️</span
                  >{{ $t("matterProgram.matterForm.selectableIn") }}
                  {{
                    $getVisibleNames(
                      "mesh.basematterwrapper",
                      false,
                      "Módulo Electivo Genérico"
                    )
                  }}
                  <span
                    ><InfoTooltip
                      class="info-icon"
                      :tooltip_text="
                        $t(
                          'matterProgram.matterForm.necessaryForRegistration',
                          {
                            entity: $getVisibleNames(
                              'mesh.basematterwrapper',
                              false,
                              'Módulo Electivo Genérico'
                            ),
                          }
                        )
                      "
                    >
                    </InfoTooltip
                  ></span>
                </div>
              </div>
            </template>
            <div id="credit">
              <div class="d-flex">
                <div class="noprint">
                  <span
                    :class="{
                      'font-weight-bold': old_matter.is_elective,
                    }"
                    >{{ $t("reusable.common.yes") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': old_matter.is_closed }"
                    @click="
                      () => {
                        if (!old_matter.is_closed)
                          old_matter.is_elective = !old_matter.is_elective;
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !old_matter.is_elective,
                        'icon-check-disabled': old_matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !old_matter.is_elective,
                    }"
                    >{{ $t("reusable.common.no") }}</span
                  >
                </div>
              </div>
            </div></b-form-group
          >
          <b-form-group label-cols="0" label-cols-sm="5" class="label m-0">
            <template #label>
              <div class="distribution_teaching_profile_hours-label">
                <div class="label-content ml-1">
                  <span
                    v-if="
                      !old_matter.is_closed &&
                      !(institution && institution.internal_use_id == 'duoc.cl')
                    "
                    v-b-tooltip.v-secondary.noninteractive="
                      $t('matterProgram.matterForm.changesReflectedTooltip', {
                        entity: $getVisibleNames(
                          'mesh.egressprofilematter',
                          true,
                          'Asignaturas'
                        ).toLowerCase(),
                      })
                    "
                    >⚠️</span
                  >
                  {{
                    institution && institution.internal_use_id == "duoc.cl"
                      ? $t("matterProgram.matterForm.distributeCoTeachingHours")
                      : $t(
                          "matterProgram.matterForm.distributeTeacherProfileHours"
                        )
                  }}
                  <span
                    ><InfoTooltip
                      class="info-icon"
                      :tooltip_text="
                        $t(
                          'matterProgram.matterForm.enableHoursDistributionTooltip',
                          {
                            entity: $getVisibleNames(
                              'mesh.egressprofilematter',
                              true,
                              'Asignaturas'
                            ),
                          }
                        )
                      "
                    >
                    </InfoTooltip
                  ></span>
                </div>
              </div>
            </template>
            <div id="distribution_teaching_profile_hours">
              <div class="d-flex">
                <div class="noprint">
                  <span
                    :class="{
                      'font-weight-bold':
                        old_matter.distribution_teaching_profile_hours,
                    }"
                    >{{ $t("reusable.common.yes") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': old_matter.is_closed }"
                    @click="
                      () => {
                        if (!old_matter.is_closed)
                          old_matter.distribution_teaching_profile_hours =
                            !old_matter.distribution_teaching_profile_hours;
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active':
                          !old_matter.distribution_teaching_profile_hours,
                        'icon-check-disabled': old_matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold':
                        !old_matter.distribution_teaching_profile_hours,
                    }"
                    >{{ $t("reusable.common.no") }}</span
                  >
                </div>
              </div>
            </div>
          </b-form-group>
          <b-form-group label-cols="0" label-cols-sm="5" class="label m-0">
            <template #label>
              <div class="learning_result_locked_view-label">
                <div class="ml-1">
                  <span
                    v-if="
                      !old_matter.is_closed &&
                      !(institution && institution.internal_use_id == 'duoc.cl')
                    "
                    >⚠️</span
                  >
                  {{
                    $t("matterProgram.matterForm.lockRaMicroCreation", {
                      entity: $getVisibleNames(
                        "teaching.ramicro",
                        false,
                        "RA Micro"
                      ),
                      context:
                        institution && institution.internal_use_id == "duoc.cl"
                          ? "PMD"
                          : $getVisibleNames(
                              "manual.matter_program",
                              false,
                              "Programa de Asignatura"
                            ),
                    })
                  }}
                  <span
                    ><InfoTooltip
                      class="info-icon"
                      :tooltip_text="
                        $t(
                          'matterProgram.matterForm.enableRaMicroCreationTooltip',
                          {
                            entity: $getVisibleNames(
                              'teaching.ramicro',
                              false,
                              'RA Micro'
                            ),
                            context: $getVisibleNames(
                              'manual.matter_program',
                              false,
                              'Programa de Asignatura'
                            ),
                          }
                        )
                      "
                    >
                    </InfoTooltip
                  ></span>
                </div>
              </div>
            </template>
            <div id="learning_result_locked_view">
              <div class="d-flex">
                <div class="noprint">
                  <span
                    :class="{
                      'font-weight-bold':
                        old_matter.learning_result_locked_view,
                    }"
                    >{{ $t("reusable.common.yes") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': old_matter.is_closed }"
                    @click="
                      () => {
                        if (!old_matter.is_closed)
                          old_matter.learning_result_locked_view =
                            !old_matter.learning_result_locked_view;
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active':
                          !old_matter.learning_result_locked_view,
                        'icon-check-disabled': old_matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold':
                        !old_matter.learning_result_locked_view,
                    }"
                    >{{ $t("reusable.common.no") }}</span
                  >
                </div>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            label-cols="0"
            label-cols-sm="5"
            class="label m-0"
            v-if="
              !(institution && institution.internal_use_id == 'duoc.cl') ||
              !matter.use_matter_values
            "
          >
            <template #label>
              <div class="weighing-label">
                <div class="label-content">
                  {{
                    $t("matterProgram.matterForm.linkEntity", {
                      entity: $getVisibleNames(
                        "teaching.matter",
                        false,
                        "Asignatura Base"
                      ),
                    }).toUpperCase()
                  }}
                  <InfoPopoverComparison
                    class="info-icon"
                    id_popover="link-entity-info"
                    :title="
                      $t('matterProgram.matterForm.linkEntityPopoverTitle', {
                        entity: $getVisibleNames(
                          'teaching.matter',
                          false,
                          'Asignatura Base'
                        ),
                      })
                    "
                    title_icon="link45deg"
                    :sections="linkEntityPopoverSections"
                  ></InfoPopoverComparison>
                </div>
              </div>
            </template>
            <div id="credit">
              <div class="d-flex">
                <div class="noprint">
                  <span
                    :class="{
                      'font-weight-bold': matter.use_matter_values,
                    }"
                    >{{ $t("reusable.common.yes") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': matter.is_closed }"
                    @click="
                      () => {
                        if (!matter.is_closed) {
                          matter.use_matter_values = !matter.use_matter_values;
                          if (
                            !matter.use_matter_values &&
                            !isNaN(old_matter.id)
                          )
                            copyMatterToEgressProfileMatter(old_matter.id);
                        }
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !matter.use_matter_values,
                        'icon-check-disabled': matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !matter.use_matter_values,
                    }"
                    >{{ $t("reusable.common.no") }}</span
                  >
                </div>
              </div>
            </div></b-form-group
          >
          <!-- matter.use_matter_values -->
          <b-form-group
            v-if="matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            label-for="input-modality"
            class="label my-2 mx-0"
          >
            <template v-slot:label>
              <!-- <b-icon
            v-b-tooltip.v-secondary.noninteractive="
              `Los cambios en este campo se verán reflejados en todas las ${$getVisibleNames(
                'mesh.egressprofilematter',
                true,
                'Asignaturas'
              ).toLowerCase()}`
            "
            icon="exclamation-triangle"
            style="margin-bottom: 0.1rem"
          ></b-icon> -->
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(institution && institution.internal_use_id == 'duoc.cl')
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️</span
              >
              {{
                $getVisibleNames(
                  "mesh.modality",
                  false,
                  "Modalidad de Asignatura"
                )
              }}
            </template>
            <v-select
              id="input-modality"
              class="input-modality"
              :options="modalities"
              v-model="$v.old_matter.modalities.$model"
              :reduce="(modalities) => modalities.id"
              :state="validateState('modalities')"
              :disabled="old_matter.is_closed"
              :placeholder="`${
                modalities.length > 0
                  ? String(
                      $t('reusable.common.selectOneOrManyFeminine', {
                        entity: $getVisibleNames(
                          'mesh.modality',
                          true,
                          'Modalidades de Asignatura'
                        ),
                      })
                    )
                  : String(
                      $t('reusable.common.noCreated', {
                        entity: $getVisibleNames(
                          'mesh.modality',
                          true,
                          'Modalidades de Asignatura'
                        ),
                      })
                    )
              }`"
              multiple
              :selectable="
                (option) => !old_matter.modalities.includes(option.id)
              "
              label="name"
              track-by="id"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("reusable.common.noOptions") }} <em>{{ search }}</em
                  >.
                </template>
              </template>
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
          <b-form-group
            v-if="matter.use_matter_values && studyEnvironments.length > 0"
            label-cols="0"
            label-cols-sm="3"
            label-for="input-study_environments"
            class="label my-2 mx-0"
          >
            <template v-slot:label>
              <!-- <b-icon
            v-b-tooltip.v-secondary.noninteractive="
              `Los cambios en este campo se verán reflejados en todas las ${$getVisibleNames(
                'mesh.egressprofilematter',
                true,
                'Asignaturas'
              ).toLowerCase()}`
            "
            icon="exclamation-triangle"
            style="margin-bottom: 0.1rem"
          ></b-icon> -->
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(institution && institution.internal_use_id == 'duoc.cl')
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️</span
              >
              {{
                $getVisibleNames(
                  "mesh.studyenvironment",
                  false,
                  "Ambiente de Aprendizaje"
                )
              }}
            </template>
            <v-select
              id="input-study_environments"
              v-model="$v.old_matter.study_environments.$model"
              :options="studyEnvironments"
              :reduce="(studyEnvironments) => studyEnvironments.id"
              :disabled="old_matter.is_closed"
              :placeholder="`${
                studyEnvironments.length > 0
                  ? String(
                      $t('reusable.common.selectOneOrMany', {
                        entity: $getVisibleNames(
                          'mesh.studyenvironment',
                          false,
                          'Ambientes de Estudio'
                        ),
                      })
                    )
                  : String(
                      $t('reusable.common.noCreated', {
                        entity: $getVisibleNames(
                          'mesh.studyenvironment',
                          false,
                          'Ambientes de Estudio'
                        ),
                      })
                    )
              }`"
              multiple
              :selectable="
                (option) => !old_matter.study_environments.includes(option.id)
              "
              :dropdown-should-open="dropdownShouldOpen2"
              :state="validateState('study_environments')"
              label="name"
              track-by="id"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("reusable.common.noOptions") }} "<em>{{ search }}</em
                  >"
                </template>
              </template>
            </v-select>
            <b-tooltip
              target="input-study_environments"
              variant="secondary"
              :noninteractive="true"
              triggers="hover"
            >
              <div v-if="studyEnvironments.length == 0">
                {{
                  $t("matterProgram.matterForm.goToCurricularDefinitions", {
                    entity: $getVisibleNames(
                      "mesh.studyenvironment",
                      false,
                      "Ambiente de Aprendizaje"
                    ).toLowerCase(),
                  })
                }}
              </div>
            </b-tooltip>
          </b-form-group>
          <MatterStudyEnvironment
            :key="`mse-old-matter-${old_matter.id}`"
            ref="matterStudyEnvironmentOldMatter"
            v-if="old_matter && matter.use_matter_values"
            :old_matter="old_matter"
            :studyEnvironments="selectedStudyEnvironmentsOldMatter"
          >
          </MatterStudyEnvironment>
          <b-form-group
            v-if="old_matter && !editsEgressProfileMatterTypes"
            label-cols="0"
            label-cols-sm="3"
            :label="
              $getVisibleNames('mesh.mattertype', false, 'Tipo de Asignatura')
            "
            label-for="input-matter-type"
            class="label my-2"
          >
            <v-select
              id="input-matter-type"
              v-model="$v.old_matter.matter_types.$model"
              :options="matterTypes"
              :reduce="(matterTypes) => matterTypes.id"
              multiple
              :selectable="
                (option) => !old_matter.matter_types.includes(option.id)
              "
              :placeholder="
                $t('reusable.common.selectOneOrMany', {
                  entity: $getVisibleNames(
                    'mesh.mattertype',
                    true,
                    'Tipos de Asignatura'
                  ),
                })
              "
              :disabled="!allow_crud || old_matter.is_closed"
              :state="validateOldMatter('matter_types')"
              label="name"
              track-by="id"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("reusable.common.noOptions") }} <em>{{ search }}</em
                  >.
                </template>
              </template>
            </v-select>
          </b-form-group>
          <b-form-group
            v-if="
              matter &&
              matter.use_matter_values &&
              institution &&
              institution.internal_use_id == 'duoc.cl'
            "
            label-cols="0"
            label-cols-sm="3"
            :label="$t('matterProgram.matterForm.matterCategory')"
            label-for="input-matter_category"
            class="label my-2 mx-0"
          >
            <v-select
              id="input-matter_category"
              v-model="$v.old_matter.matter_category.$model"
              :options="matterCategories"
              :reduce="(matterCategories) => matterCategories.id"
              :placeholder="`${
                matterCategories.length > 0
                  ? String($t('matterProgram.matterForm.selectCategory'))
                  : String($t('matterProgram.matterForm.noCategoriesCreated'))
              }`"
              :dropdown-should-open="dropdownShouldOpenMatterCategory"
              :state="validateOldMatter('matter_category')"
              label="name"
              track-by="id"
              :disabled="!allow_crud || old_matter.is_closed"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("matterProgram.matterForm.noResultsFor") }} "<em>{{
                    search
                  }}</em
                  >"
                </template>
              </template>
            </v-select>
          </b-form-group>
          <b-form-group
            v-if="matterLanguages.length > 1"
            label-cols="0"
            label-cols-sm="3"
            :label="$t('matterProgram.matterForm.defaultLanguage')"
            label-for="input-default_language"
            class="label my-2 mx-0"
          >
            <template #label>
              <div class="d-flex">
                <span>
                  {{ $t("matterProgram.matterForm.defaultLanguage") }}
                </span>
                <InfoPopover
                  :id_popover="'info-default-language'"
                  class="ml-2"
                  placement="right"
                >
                  <template #title>
                    <div>
                      {{
                        $t("matterProgram.matterForm.defaultLanguageViewsTitle")
                      }}
                    </div>
                  </template>
                  <div class="px-2">
                    <li>
                      {{
                        $getVisibleNames(
                          "manual.matter_program",
                          false,
                          "Programa de la Asignatura"
                        )
                      }}
                    </li>
                    <li>
                      {{
                        $t("matterProgram.matterForm.defaultLanguageViewEval", {
                          name: $getVisibleNames(
                            "evaluations2.evaluation",
                            false,
                            "Evaluación"
                          ),
                        })
                      }}
                    </li>
                    <li>
                      {{
                        $t(
                          "matterProgram.matterForm.defaultLanguageTeacherView",
                          {
                            name: $getVisibleNames(
                              "evaluations2.evaluation",
                              true,
                              "Evaluaciones"
                            ),
                          }
                        )
                      }}
                    </li>
                    <li>
                      {{
                        $t(
                          "matterProgram.matterForm.defaultLanguageStudentView",
                          {
                            name: $getVisibleNames(
                              "evaluations2.evaluation",
                              true,
                              "Evaluaciones"
                            ),
                          }
                        )
                      }}
                    </li>
                    <li>
                      {{
                        $t(
                          "matterProgram.matterForm.defaultLanguageOutputFormat",
                          {
                            name: $getVisibleNames(
                              "evaluations2.evaluation",
                              true,
                              "Evaluaciones"
                            ),
                          }
                        )
                      }}
                    </li>
                    <span
                      v-if="
                        institution && institution.internal_use_id == 'duoc.cl'
                      "
                    >
                      <li>
                        {{
                          $t(
                            "matterProgram.matterForm.defaultLanguageOutputLearningExp"
                          )
                        }}
                      </li>
                      <li>
                        {{
                          $t(
                            "matterProgram.matterForm.defaultLanguageOutputSubjectDesc"
                          )
                        }}
                      </li>
                      <li>
                        {{
                          $t("matterProgram.matterForm.defaultLanguageOutputPA")
                        }}
                      </li>
                      <li>
                        {{
                          $t(
                            "matterProgram.matterForm.defaultLanguageOutputPDA"
                          )
                        }}
                      </li>
                      <li>
                        {{
                          $t(
                            "matterProgram.matterForm.defaultLanguageOutputPIA"
                          )
                        }}
                      </li>
                    </span>
                  </div>
                </InfoPopover>
              </div>
            </template>
            <v-select
              id="input-default_language"
              v-model="old_matter.default_language"
              :options="matterLanguages"
              :reduce="(lang) => lang.id"
              :placeholder="$t('matterProgram.matterForm.noDefaultLanguage')"
              label="name"
              track-by="id"
              :disabled="!allow_crud || old_matter.is_closed"
              size="sm"
            >
              <template #option="{ name, code }">
                <img
                  v-if="flagMap[code]"
                  :src="flagMap[code]"
                  :alt="code"
                  style="
                    width: 18px;
                    border-radius: 2px;
                    margin-right: 6px;
                    vertical-align: middle;
                  "
                />
                <span>{{ name }}</span>
              </template>
              <template #selected-option="{ name, code }">
                <img
                  v-if="flagMap[code]"
                  :src="flagMap[code]"
                  :alt="code"
                  style="
                    width: 18px;
                    border-radius: 2px;
                    margin-right: 6px;
                    vertical-align: middle;
                  "
                />
                <span>{{ name }}</span>
              </template>
            </v-select>
          </b-form-group>
          <!-- PUCV: el crédito va antes de las horas porque con él se validan. -->
          <b-form-group
            v-if="matter.use_matter_values && usesPucvCredits"
            label-cols="0"
            label-cols-sm="3"
            label-for="input-pucv_credits"
            class="label my-2 mx-0"
          >
            <template v-slot:label>
              <span
                v-if="!old_matter.is_closed"
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️</span
              >
              {{ pucvCreditsLabel }}
            </template>
            <b-form-input
              id="input-pucv_credits"
              v-model="$v.old_matter.institutional_credits.$model"
              :disabled="old_matter.is_closed"
              type="number"
              min="0"
              :state="validateOldMatter('institutional_credits')"
              aria-describedby="input-pucv_credits-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-pucv_credits-feedback">{{
              $t("reusable.common.greaterThanOrEqualToZero")
            }}</b-form-invalid-feedback>
            <small class="text-muted">{{ pucvCreditsReferenceText }}</small>
          </b-form-group>
          <!-- PUCV: los SCT salen del crédito PUCV, por eso van junto a él. -->
          <b-form-group
            v-if="matter.use_matter_values && usesPucvCredits"
            label-cols="0"
            label-cols-sm="3"
            label-for="credit"
            class="label"
          >
            <template #label>
              <div>
                <!-- <b-icon
              v-b-tooltip.v-secondary.noninteractive="
                `Los cambios en este campo se verán reflejados en todas las ${$getVisibleNames(
                  'mesh.egressprofilematter',
                  true,
                  'Asignaturas'
                ).toLowerCase()}`
              "
              icon="exclamation-triangle"
              style="margin-bottom: 0.1rem"
            ></b-icon> -->
                <span
                  v-if="
                    !old_matter.is_closed &&
                    !(institution && institution.internal_use_id == 'duoc.cl')
                  "
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('matterProgram.matterForm.changesReflectedTooltip2', {
                      entity: $getVisibleNames(
                        'mesh.egressprofilematter',
                        true,
                        'Asignaturas'
                      ).toLowerCase(),
                    })
                  "
                  >⚠️</span
                >
                {{
                  $getVisibleNames(
                    "manual.credits",
                    true,
                    "Créditos SCT Totales"
                  )
                }}
                <span>
                  <InfoTooltip
                    class="info-icon"
                    :tooltip_text="pucvSctFormulaText"
                  >
                  </InfoTooltip>
                </span>
              </div>
            </template>
            <div id="credit">
              <div class="d-flex">
                <b-badge class="credits-value mb-0" variant="light">
                  {{ creditSctChile }}
                </b-badge>
                <div
                  class="toggle-types noprint"
                  v-b-tooltip.v-secondary.hover="$t('reusable.common.credit')"
                >
                  <span
                    :class="{
                      'font-weight-bold': old_matter.use_automatic_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.automatic") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': old_matter.is_closed }"
                    @click="
                      () => {
                        if (!old_matter.is_closed) slotCheckCredits();
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !old_matter.use_automatic_credits,
                        'icon-check-disabled': old_matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !old_matter.use_automatic_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.planned") }}</span
                  >
                </div>
                <b-form-input
                  id="input-credits"
                  type="number"
                  min="0"
                  class="ml-2"
                  :disabled="
                    old_matter.use_automatic_credits || old_matter.is_closed
                  "
                  v-model="$v.old_matter.credits.$model"
                  :state="validateState('credits')"
                  aria-describedby="input-credits-feedback"
                  size="sm"
                ></b-form-input>
                <b-tooltip
                  :target="`input-credits`"
                  variant="secondary"
                  :noninteractive="true"
                >
                  <div v-if="old_matter.credits < 0">
                    {{ $t("reusable.common.greaterThanOrEqualToZero") }}
                  </div>
                </b-tooltip>
              </div>
            </div>
            <b-alert
              v-if="pucvSctMismatch"
              show
              variant="warning"
              class="pucv-credits-alert"
            >
              <b-icon icon="exclamation-triangle"></b-icon>
              {{ pucvSctMismatchText }}
            </b-alert>
          </b-form-group>
          <b-form-group
            v-if="matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            label-for="input-weeks"
            class="label my-2 mx-0"
          >
            <template v-slot:label>
              <!-- <b-icon
            v-b-tooltip.v-secondary.noninteractive="
              `Los cambios en este campo se verán reflejados en todas las ${$getVisibleNames(
                'mesh.egressprofilematter',
                true,
                'Asignaturas'
              ).toLowerCase()}`
            "
            icon="exclamation-triangle"
            style="margin-bottom: 0.1rem"
           ></b-icon> -->
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(institution && institution.internal_use_id == 'duoc.cl')
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️</span
              >
              {{ $t("matterProgram.matterForm.weeks") }}
            </template>
            <b-form-input
              id="input-weeks"
              v-model="$v.old_matter.weeks.$model"
              :disabled="old_matter.is_closed"
              type="number"
              min="0"
              :state="validateState('weeks')"
              v-b-tooltip.v-secondary.top.noninteractive="
                $t('matterProgram.matterForm.changeWeeksWarning', {
                  entity1: $getVisibleNames(
                    'manual.total_pedagogical_hours',
                    true,
                    'Total de Horas Pedagógicas'
                  ),
                  entity2: $getVisibleNames(
                    'manual.total_chronological_hours',
                    true,
                    'Total de Horas Cronológicas'
                  ),
                })
              "
              aria-describedby="input-weeks-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-weeks-feedback">{{
              $t("reusable.common.integerGreaterThanZero")
            }}</b-form-invalid-feedback>
          </b-form-group>
          <MatterTimeAllocationComponent
            v-if="
              matter.use_matter_values &&
              step_matter &&
              disabled_component_hours_in_save
            "
            :key="reload_matter_time_allocation"
            :oldMatter="old_matter"
            :profileType="profileType"
            @updated="slotUpdateOldMatterHours"
          >
          </MatterTimeAllocationComponent>
          <b-form-group
            v-if="
              matter.use_matter_values &&
              showPedagogicalHours &&
              showChronologicalHours
            "
            label-cols="0"
            label-cols-sm="4"
            label-for="total_hours"
            class="label mb-0"
          >
            <template #label>
              <div>
                {{
                  $getVisibleNames(
                    "manual.total_hours_sum_to_chronological",
                    true,
                    "Total de Horas (Pedagógicas + Cronológicas)"
                  )
                }}
                <span>
                  <InfoTooltip
                    class="info-icon"
                    :tooltip_text="`${$getVisibleNames(
                      'manual.total_pedagogical_hours_to_chronological',
                      true,
                      'Total de Horas Pedagógicas (En Cronológicas)'
                    )} + ${$getVisibleNames(
                      'manual.total_chronological_hours',
                      true,
                      'Total de Horas Cronológicas'
                    )}`"
                  >
                  </InfoTooltip>
                </span>
              </div>
            </template>
            <div>
              <b-badge
                id="total_hours"
                class="total-hours-value mt-1"
                variant="light"
              >
                {{ totalHours }}
              </b-badge>
            </div>
          </b-form-group>
          <b-alert
            v-if="matter.use_matter_values && pucvHoursExceeded"
            show
            variant="warning"
            class="pucv-credits-alert"
          >
            <b-icon icon="exclamation-triangle"></b-icon>
            {{ pucvHoursExceededText }}
          </b-alert>
          <b-form-group
            v-if="matter.use_matter_values && !usesPucvCredits"
            label-cols="0"
            label-cols-sm="4"
            label-for="credit"
            class="label"
          >
            <template #label>
              <div>
                <!-- <b-icon
              v-b-tooltip.v-secondary.noninteractive="
                `Los cambios en este campo se verán reflejados en todas las ${$getVisibleNames(
                  'mesh.egressprofilematter',
                  true,
                  'Asignaturas'
                ).toLowerCase()}`
              "
              icon="exclamation-triangle"
              style="margin-bottom: 0.1rem"
            ></b-icon> -->
                <span
                  v-if="
                    !old_matter.is_closed &&
                    !(institution && institution.internal_use_id == 'duoc.cl')
                  "
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('matterProgram.matterForm.changesReflectedTooltip2', {
                      entity: $getVisibleNames(
                        'mesh.egressprofilematter',
                        true,
                        'Asignaturas'
                      ).toLowerCase(),
                    })
                  "
                  >⚠️</span
                >
                {{
                  $getVisibleNames(
                    "manual.credits",
                    true,
                    "Créditos SCT Totales"
                  )
                }}
                <span>
                  <InfoTooltip
                    class="info-icon"
                    :tooltip_text="`${$getVisibleNames(
                      'manual.total_hours_sum_to_chronological',
                      true,
                      'Total de Horas (Pedagógicas + Cronológicas)'
                    )}(${totalHours}) / ${$t(
                      'matterProgram.matterForm.hoursPerCredit'
                    )} ${$getVisibleNames(
                      'manual.credits',
                      true,
                      'Créditos SCT Totales'
                    )}(${institution.hours_per_credit})`"
                  >
                  </InfoTooltip>
                </span>
              </div>
            </template>
            <div id="credit">
              <div class="d-flex">
                <b-badge class="credits-value mb-0" variant="light">
                  {{ creditSctChile }}
                </b-badge>
                <div
                  class="toggle-types noprint"
                  v-b-tooltip.v-secondary.hover="$t('reusable.common.credit')"
                >
                  <span
                    :class="{
                      'font-weight-bold': old_matter.use_automatic_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.automatic") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': old_matter.is_closed }"
                    @click="
                      () => {
                        if (!old_matter.is_closed) slotCheckCredits();
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !old_matter.use_automatic_credits,
                        'icon-check-disabled': old_matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !old_matter.use_automatic_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.planned") }}</span
                  >
                </div>
                <b-form-input
                  id="input-credits"
                  type="number"
                  min="0"
                  class="ml-2"
                  :disabled="
                    old_matter.use_automatic_credits || old_matter.is_closed
                  "
                  v-model="$v.old_matter.credits.$model"
                  :state="validateState('credits')"
                  aria-describedby="input-credits-feedback"
                  size="sm"
                ></b-form-input>
                <b-tooltip
                  :target="`input-credits`"
                  variant="secondary"
                  :noninteractive="true"
                >
                  <div v-if="old_matter.credits < 0">
                    {{ $t("reusable.common.greaterThanOrEqualToZero") }}
                  </div>
                </b-tooltip>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            v-if="
              matter.use_matter_values &&
              $hasInstitutionalCredits(institution) &&
              !usesPucvCredits
            "
            label-cols="0"
            label-cols-sm="4"
            label-for="input-institutional_credits"
            class="label"
          >
            <template v-slot:label>
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(institution && institution.internal_use_id == 'duoc.cl')
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️
              </span>
              {{
                $getVisibleNames(
                  "manual.institutional_credits",
                  false,
                  "Créditos Institucionales"
                )
              }}
              <span
                v-if="
                  profileType &&
                  $getInstitutionalCreditsFormula(institution) == 'duoc'
                "
              >
                <InfoTooltip
                  class="info-icon"
                  :tooltip_text="`${$getVisibleNames(
                    'manual.total_pedagogical_hours_to_chronological',
                    true,
                    'Total de Horas Pedagógicas (En Cronológicas)'
                  )}/9 => (${totalPedagogical})/9 = ${parseFloat(
                    (totalPedagogical / 9).toFixed(2)
                  )}`"
                >
                </InfoTooltip>
              </span>
              <span
                v-if="
                  profileType &&
                  $getInstitutionalCreditsFormula(institution) == 'unab'
                "
              >
                <InfoTooltip
                  class="info-icon"
                  :tooltip_text="`${$getVisibleNames(
                    'manual.total_pedagogical_hours',
                    true,
                    'Total de Horas Pedagógicas'
                  )}(${totalPedagogical})/${$t(
                    'matterProgram.matterForm.weeks'
                  )} + (${$getVisibleNames(
                    'manual.total_chronological_hours',
                    true,
                    'Total de Horas Cronológicas'
                  )}(${totalChronological})/${$t(
                    'matterProgram.matterForm.weeks'
                  )})*(60/${profileType.module_minutes})
                  `"
                >
                </InfoTooltip>
              </span>
            </template>
            <div id="credit">
              <div class="d-flex">
                <b-badge class="credits-value mb-0" variant="light">
                  {{ institutionalCredits }}
                </b-badge>
                <div
                  class="toggle-types noprint"
                  v-b-tooltip.v-secondary.hover="$t('reusable.common.credit')"
                >
                  <span
                    :class="{
                      'font-weight-bold':
                        old_matter.use_automatic_institutional_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.automatic") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': old_matter.is_closed }"
                    @click="
                      () => {
                        if (!old_matter.is_closed)
                          slotCheckInstitutionalCredits();
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active':
                          !old_matter.use_automatic_institutional_credits,
                        'icon-check-disabled': old_matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold':
                        !old_matter.use_automatic_institutional_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.planned") }}</span
                  >
                </div>
                <b-form-input
                  id="input-institutional_credits"
                  type="number"
                  min="0"
                  class="ml-2"
                  :disabled="
                    old_matter.use_automatic_institutional_credits ||
                    old_matter.is_closed
                  "
                  v-model="$v.old_matter.institutional_credits.$model"
                  :state="validateState('institutional_credits')"
                  aria-describedby="input-institutional_credits-feedback"
                  size="sm"
                ></b-form-input>
                <b-tooltip
                  :target="`input-institutional_credits`"
                  variant="secondary"
                  :noninteractive="true"
                >
                  <div v-if="old_matter.institutional_credits < 0">
                    {{ $t("reusable.common.greaterThanOrEqualToZero") }}
                  </div>
                </b-tooltip>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            v-if="matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            label-for="input-suggested_students"
            class="label mt-2"
          >
            <template v-slot:label>
              <!-- <b-icon
            v-b-tooltip.v-secondary.noninteractive="
              `Los cambios en este campo se verán reflejados en todas las ${$getVisibleNames(
                'mesh.egressprofilematter',
                true,
                'Asignaturas'
              ).toLowerCase()}`
            "
            icon="exclamation-triangle"
            style="margin-bottom: 0.1rem"
          ></b-icon> -->
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(institution && institution.internal_use_id == 'duoc.cl')
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️</span
              >
              {{
                $t("matterProgram.matterForm.numberOf", {
                  entity: $t("matterProgram.matterForm.students"),
                })
              }}
            </template>
            <b-form-input
              id="input-suggested_students"
              type="number"
              min="0"
              v-model="$v.old_matter.suggested_students.$model"
              :disabled="old_matter.is_closed"
              :state="validateState('suggested_students')"
              aria-describedby="input-suggested_students-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-suggested_students-feedback">{{
              $t("reusable.common.greaterThanOrEqualToZero")
            }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            v-if="matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            label-for="input-suggested_teachers"
            class="label mt-2"
          >
            <template v-slot:label>
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(institution && institution.internal_use_id == 'duoc.cl')
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️</span
              >
              {{
                $t("matterProgram.matterForm.numberOf", {
                  entity: $t("matterProgram.matterForm.teachers"),
                })
              }}
            </template>
            <b-form-input
              id="input-suggested_teachers"
              type="number"
              min="0"
              v-model="$v.old_matter.suggested_teachers.$model"
              :disabled="old_matter.is_closed"
              :state="validateState('suggested_teachers')"
              aria-describedby="input-suggested_teachers-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-suggested_teachers-feedback">{{
              $t("reusable.common.greaterThanOrEqualToZero")
            }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            v-if="matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            label-for="input-suggested_assistants"
            class="label mt-2"
          >
            <template v-slot:label>
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(institution && institution.internal_use_id == 'duoc.cl')
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️</span
              >
              {{
                $t("matterProgram.matterForm.numberOf", {
                  entity: $t("matterProgram.matterForm.assistants"),
                })
              }}
            </template>
            <b-form-input
              id="input-suggested_assistants"
              type="number"
              min="0"
              v-model="$v.old_matter.suggested_assistants.$model"
              :disabled="old_matter.is_closed"
              :state="validateOldMatter('suggested_assistants')"
              aria-describedby="input-suggested_assistants-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-suggested_assistants-feedback">{{
              $t("reusable.common.greaterThanOrEqualToZero")
            }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            v-if="
              matter &&
              matter.use_matter_values &&
              institution &&
              institution.internal_use_id == 'iacc.cl'
            "
            label-cols="0"
            label-cols-sm="3"
            label-for="is_exemptable_old"
            class="label align-middle mb-2"
          >
            <template #label>
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(institution && institution.internal_use_id == 'duoc.cl')
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase(),
                  })
                "
                >⚠️</span
              >
              {{ $t("matterProgram.matterForm.isExemptable") }}
            </template>
            <div id="is_exemptable_old" class="align-middle">
              <div class="d-flex">
                <div class="toggle-types noprint">
                  <span
                    :class="{
                      'font-weight-bold': old_matter.is_exemptable,
                    }"
                    >{{ $t("reusable.common.yes") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': old_matter.is_closed }"
                    @click="
                      () => {
                        if (!old_matter.is_closed)
                          old_matter.is_exemptable = !old_matter.is_exemptable;
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !old_matter.is_exemptable,
                        'icon-check-disabled': old_matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !old_matter.is_exemptable,
                    }"
                    >{{ $t("reusable.common.no") }}</span
                  >
                </div>
              </div>
            </div>
          </b-form-group>
          <!-- <b-form-group
            v-if="matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            label-for="input-publish_date"
            class="label mt-2"
          >
            <template v-slot:label>
              <span
                v-if="
                  !old_matter.is_closed &&
                  !(
                    (institution && institution.internal_use_id == 'duoc.cl')
                  )
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase()
                  })
                "
                >⚠️</span
              >
              Fecha de Publicación
            </template>
            <b-form-datepicker
              id="input-publish_date"
              v-model="$v.old_matter.publish_date.$model"
              :disabled="old_matter.is_closed"
              :state="validateOldMatter('publish_date')"
              aria-describedby="input-publish_date-feedback"
              size="sm"
            ></b-form-datepicker>
            <b-form-invalid-feedback id="input-publish_date-feedback"
              >{{ $t('reusable.common.greaterThanOrEqualToZero') }}</b-form-invalid-feedback
            >
          </b-form-group> -->

          <template v-if="isClosedOldMatter && !isNaN(old_matter.id)">
            <div class="text-right mr-1">
              <div class="btn-close-matter">
                <!-- v-b-tooltip.v-secondary.noninteractive="
                    `${
                      !theTestsHaveSomeErrors ||
                      (old_matter && old_matter.is_closed)
                        ? $t('matterProgram.matterForm.changeStatusOf', {
                            entity: $getVisibleNames(
                              'teaching.matter',
                              false,
                              'Asignatura Base'
                            )
                          })
                        : ''
                    }`
                  " -->
                <b-button
                  size="sm"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('matterProgram.matterForm.changeStatusTooltip', {
                      entity: $getVisibleNames(
                        'teaching.matter',
                        false,
                        'Asignatura Base'
                      ),
                    })
                  "
                  @click="changeStateOldMatter()"
                >
                  <!-- :disabled="
                    theTestsHaveSomeErrors &&
                    old_matter &&
                    !old_matter.is_closed
                  " -->
                  <template v-if="old_matter && old_matter.is_closed">
                    {{ $t("reusable.common.open") }}
                    {{
                      $getVisibleNames(
                        "teaching.matter",
                        false,
                        "Asignatura Base"
                      )
                    }}
                    <b-icon icon="lock" scale="1"></b-icon>
                  </template>
                  <template v-else>
                    {{ $t("reusable.common.close") }}
                    {{
                      $getVisibleNames(
                        "teaching.matter",
                        false,
                        "Asignatura Base"
                      )
                    }}
                    <b-icon icon="unlock" scale="1"></b-icon>
                  </template>
                </b-button>
                <!--  v-if="
                    (theTestsHaveSomeErrors ||
                      theTestsNotYetClose ||
                      excludeECMicro.length > 0) &&
                    institution &&
                    institution.internal_use_id == 'duoc.cl' &&
                    old_matter &&
                    !old_matter.is_closed
                  " -->
                <span
                  v-if="
                    (theTestsHaveSomeErrors ||
                      theTestsNotYetClose ||
                      excludeECMicro.length > 0) &&
                    institution &&
                    institution.internal_use_id == 'duoc.cl' &&
                    old_matter
                  "
                  class="ml-2"
                >
                  <!-- no puede cerrarse dado que cuenta con algunos errores que se deben corregir. Para más información presione el botón. -->
                  <ButtonErrorInstrument
                    variant="danger"
                    :popover_text="
                      $t('matterProgram.matterForm.evaluationErrorsPopover', {
                        entity: $getVisibleNames(
                          'teaching.matter',
                          false,
                          'Asignatura Base'
                        ),
                      })
                    "
                    :id_popover="`old-matter-${old_matter.id}`"
                    click_modal="new-evaluation-list-modal"
                  ></ButtonErrorInstrument>
                </span>
              </div>
            </div>
          </template>
          <hr />
          <!-- !matter.use_matter_values -->
          <b-form-group
            label-cols="1"
            label-cols-sm="3"
            :label="`Número de ${$getVisibleNames(
              'mesh.egressprofilematter',
              false,
              'Asignatura'
            )}`"
            label-for="input-order"
            class="label mb-2"
            label-class="mt-2"
          >
            <b-form-input
              id="input-order"
              v-model="$v.matter.order.$model"
              :state="validateState('order')"
              type="number"
              :disabled="!allow_crud || matter.is_closed"
              aria-describedby="input-order-feedback"
              :description="
                $t('matterProgram.matterForm.defineNumberInStudyPlan', {
                  entity: $getVisibleNames(
                    'mesh.egressprofilematter',
                    false,
                    'Asignatura'
                  ),
                })
              "
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-order-feedback">{{
              $t("reusable.common.integerGreaterThanZero")
            }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            label-cols="0"
            label-cols-sm="3"
            :label="$getVisibleNames('mesh.periodtype', false, 'Régimen')"
            label-for="input-regime"
            class="label mt-1 mb-2"
          >
            <b-form-select
              id="input-regime"
              :options="regimesList"
              v-model="$v.matter.regime.$model"
              value-field="id"
              text-field="name"
              :state="validateState('regime')"
              type="number"
              :disabled="!allow_crud || matter.is_closed"
              aria-describedby="input-regime-feedback"
              size="sm"
            ></b-form-select>
            <b-form-invalid-feedback id="input-regime-feedback">{{
              $t("matterProgram.matterForm.mustSelectEntityForEntity", {
                entity1: $getVisibleNames("mesh.periodtype", false, "Régimen"),
                entity2: $getVisibleNames(
                  "mesh.egressprofilematter",
                  false,
                  "Asignatura"
                ),
              })
            }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            v-if="!$hidesFormationArea(institution)"
            label-cols="0"
            label-cols-sm="3"
            :label="
              $getVisibleNames('mesh.formationarea', false, 'Área De Formación')
            "
            label-for="input-formation-area"
            class="label my-2"
          >
            <b-form-select
              id="input-formation-area"
              :options="formationAreas"
              v-model="$v.matter.formation_area.$model"
              value-field="id"
              text-field="name"
              :state="validateState('formation_area')"
              type="number"
              :disabled="!allow_crud || matter.is_closed"
              aria-describedby="input-formation-area-feedback"
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >{{ $t("reusable.common.notApplicable") }}
                </b-form-select-option></template
              ></b-form-select
            >
            <b-form-invalid-feedback id="input-formation-area-feedback">{{
              $t("reusable.common.required")
            }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            label-cols="0"
            label-cols-sm="3"
            :label="
              $getVisibleNames(
                'mesh.formationline',
                false,
                'Línea De Formación'
              )
            "
            label-for="input-formation-line"
            class="label my-2"
          >
            <div class="d-flex">
              <div class="d-block w-100">
                <v-select
                  id="input-formation-line"
                  v-model="$v.matter.formation_line.$model"
                  :options="formationLinesList"
                  :reduce="(formationLinesList) => formationLinesList.id"
                  :placeholder="`${
                    formationLinesList.length > 0
                      ? String(
                          $t('reusable.common.selectOption', {
                            entity: $getVisibleNames(
                              'mesh.formationline',
                              false,
                              'Línea De Formación'
                            ),
                          })
                        )
                      : String(
                          $t('reusable.common.thisNoCreated', {
                            entity1: $getVisibleNames(
                              'mesh.egressprofile',
                              false,
                              'Perfil de Egreso'
                            ),
                            entity2: $getVisibleNames(
                              'mesh.formationline',
                              false,
                              'Línea De Formación'
                            ),
                          })
                        )
                  }`"
                  :dropdown-should-open="dropdownShouldOpen"
                  :state="validateState('formation_line')"
                  label="name"
                  track-by="id"
                  :disabled="!allow_crud || matter.is_closed"
                  size="sm"
                >
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      {{ $t("reusable.common.noOptions") }} "<em>{{
                        search
                      }}</em
                      >"
                    </template>
                  </template>
                </v-select>
              </div>
              <button
                v-if="career && !matter.is_closed"
                v-can="'mesh.add_formationline'"
                @click="openModalFormationLine(true)"
                class="btn-add"
                v-b-tooltip.v-secondary.noninteractive="
                  $t('reusable.common.addTooltip', {
                    entity: $getVisibleNames(
                      'mesh.formationline',
                      false,
                      'Línea De Formación'
                    ),
                  })
                "
              >
                <b-icon font-scale="1" icon="plus-square"></b-icon>
              </button>
              <button-edit
                v-if="career && matter.formation_line && !matter.is_closed"
                v-can="'mesh.change_formationline'"
                @click="openModalFormationLine(false)"
                class="btn-add"
                v-b-tooltip.v-secondary.noninteractive="
                  $t('reusable.common.editTooltip', {
                    entity: $getVisibleNames(
                      'mesh.formationline',
                      false,
                      'Línea De Formación'
                    ),
                  })
                "
              >
              </button-edit>
            </div>
            <b-tooltip
              target="input-formation-line"
              variant="secondary"
              :noninteractive="true"
              triggers="hover"
            >
              <div v-if="formationLinesList.length == 0">
                {{
                  $t("matterProgram.matterForm.goToCurricularDefinitions", {
                    entity: $getVisibleNames(
                      "mesh.formationline",
                      true,
                      "Líneas De Formación"
                    ).toLowerCase(),
                  })
                }}
              </div>
            </b-tooltip>
          </b-form-group>
          <b-form-group
            v-if="editsEgressProfileMatterTypes"
            label-cols="0"
            label-cols-sm="3"
            :label="
              $getVisibleNames('mesh.mattertype', false, 'Tipo de Asignatura')
            "
            label-for="input-matter-type"
            class="label my-2"
          >
            <v-select
              id="input-matter-type"
              v-model="$v.matter.matter_types.$model"
              :options="matterTypes"
              :reduce="(matterTypes) => matterTypes.id"
              multiple
              :selectable="(option) => !matter.matter_types.includes(option.id)"
              :placeholder="
                $t('reusable.common.selectOneOrMany', {
                  entity: $getVisibleNames(
                    'mesh.mattertype',
                    true,
                    'Tipos de Asignatura'
                  ),
                })
              "
              :disabled="!allow_crud || matter.is_closed"
              :state="validateState('matter_types')"
              label="name"
              track-by="id"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("reusable.common.noOptions") }} <em>{{ search }}</em
                  >.
                </template>
              </template>
            </v-select>
          </b-form-group>
          <b-form-group
            v-if="institution && institution.show_matter_contribution"
            label-cols="0"
            label-cols-sm="3"
            :label="`${$getVisibleNames(
              'mesh.mattercontribution',
              false,
              'Estrategia Curricular'
            )}`"
            label-for="input-matter-contribution"
            class="label my-2"
          >
            <v-select
              id="input-matter-contribution"
              :options="matterContributions"
              v-model="$v.matter.matter_contributions.$model"
              :placeholder="
                $t('reusable.common.selectOneOrManyFeminine', {
                  entity: $getVisibleNames(
                    'mesh.mattercontribution',
                    true,
                    'Estrategias Curriculares'
                  ),
                })
              "
              :reduce="(matterContributions) => matterContributions.id"
              multiple
              :selectable="
                (option) => !matter.matter_contributions.includes(option.id)
              "
              :disabled="!allow_crud || matter.is_closed"
              :state="validateState('matter_contributions')"
              label="name"
              track-by="id"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("reusable.common.noOptions") }} <em>{{ search }}</em
                  >.
                </template>
              </template>
              <template v-slot:option="option">
                <strong>{{ option.name }}: </strong>
                {{ $htmlToPlainText(option.description) }}
              </template>
            </v-select>
          </b-form-group>
          <b-form-group
            label-cols="0"
            label-cols-sm="3"
            :label="$t('matterProgram.matterForm.planLevel')"
            label-for="input-plan-level"
            class="label my-2"
          >
            <b-form-input
              id="input-plan-level"
              v-model="$v.matter.plan_level.$model"
              :state="validateState('plan_level')"
              type="number"
              :disabled="!allow_crud || matter.is_closed"
              aria-describedby="input-plan-level-live-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-plan-level-live-feedback">
              {{
                $t("matterProgram.matterForm.fieldGreaterThanAndLessOrEqual", {
                  min: 0,
                  max: egressProfile ? egressProfile.semester_amount : 0,
                })
              }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            v-if="!matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            :label="
              $getVisibleNames(
                'mesh.modality',
                false,
                'Modalidad de Asignatura'
              )
            "
            label-for="input-modality"
            class="label my-2"
          >
            <v-select
              id="input-modality"
              class="input-modality"
              :options="modalities"
              v-model="$v.matter.modalities.$model"
              :reduce="(modalities) => modalities.id"
              :state="validateState('modalities')"
              :disabled="!allow_crud || matter.is_closed"
              :placeholder="`${
                modalities.length > 0
                  ? String(
                      $t('reusable.common.selectOneOrManyFeminine', {
                        entity: $getVisibleNames(
                          'mesh.modality',
                          true,
                          'Modalidades'
                        ),
                      })
                    )
                  : String(
                      $t('reusable.common.thisNoCreated', {
                        entity1: $getVisibleNames(
                          'mesh.egressprofile',
                          false,
                          'Perfil de Egreso'
                        ),
                        entity2: $getVisibleNames(
                          'mesh.modality',
                          true,
                          'Modalidades'
                        ),
                      })
                    )
              }`"
              :selectable="(option) => !matter.modalities.includes(option.id)"
              multiple
              label="name"
              track-by="id"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("reusable.common.noOptions") }} <em>{{ search }}</em
                  >.
                </template>
              </template>
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
          <b-form-group
            v-if="!matter.use_matter_values && studyEnvironments.length > 0"
            label-cols="0"
            label-cols-sm="3"
            :label="
              $getVisibleNames(
                'mesh.studyenvironment',
                false,
                'Ambiente de Aprendizaje'
              )
            "
            label-for="input-study_environments"
            class="label my-2"
          >
            <v-select
              id="input-study_environments"
              v-model="$v.matter.study_environments.$model"
              :options="studyEnvironments"
              :reduce="(studyEnvironments) => studyEnvironments.id"
              :disabled="!allow_crud || matter.is_closed"
              :placeholder="`${
                studyEnvironments.length > 0
                  ? String(
                      $t('reusable.common.selectOneOrMany', {
                        entity: $getVisibleNames(
                          'mesh.studyenvironment',
                          false,
                          'Ambientes de Estudio'
                        ),
                      })
                    )
                  : String(
                      $t('reusable.common.noCreated', {
                        entity: $getVisibleNames(
                          'mesh.studyenvironment',
                          false,
                          'Ambientes de Estudio'
                        ),
                      })
                    )
              }`"
              :selectable="
                (option) => !matter.study_environments.includes(option.id)
              "
              multiple
              :dropdown-should-open="dropdownShouldOpen2"
              :state="validateState('study_environments')"
              label="name"
              track-by="id"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("matterProgram.matterForm.noResultsFor") }} "<em>{{
                    search
                  }}</em
                  >"
                </template>
              </template>
            </v-select>
            <b-tooltip
              target="input-study_environments"
              variant="secondary"
              :noninteractive="true"
              triggers="hover"
            >
              <div v-if="studyEnvironments.length == 0">
                {{
                  $t("matterProgram.matterForm.goToCurricularDefinitions", {
                    entity: $getVisibleNames(
                      "mesh.studyenvironment",
                      false,
                      "Ambiente de Aprendizaje"
                    ).toLowerCase(),
                  })
                }}
              </div>
            </b-tooltip>
          </b-form-group>
          <MatterStudyEnvironment
            ref="matterStudyEnvironmentMatter"
            v-if="matter && !matter.use_matter_values"
            :matter="matter"
            :studyEnvironments="selectedStudyEnvironmentsMatter"
          >
          </MatterStudyEnvironment>
          <!-- PUCV: el crédito va antes de las horas porque con él se validan. -->
          <b-form-group
            v-if="!matter.use_matter_values && usesPucvCredits"
            label-cols="0"
            label-cols-sm="3"
            :label="pucvCreditsLabel.toUpperCase()"
            label-for="input-pucv_credits"
            class="label my-2"
          >
            <b-form-input
              id="input-pucv_credits"
              v-model="$v.matter.institutional_credits.$model"
              :disabled="!allow_crud || matter.is_closed"
              type="number"
              min="0"
              :state="validateState('institutional_credits')"
              aria-describedby="input-pucv_credits-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-pucv_credits-feedback">{{
              $t("reusable.common.greaterThanOrEqualToZero")
            }}</b-form-invalid-feedback>
            <small class="text-muted">{{ pucvCreditsReferenceText }}</small>
          </b-form-group>
          <!-- PUCV: los SCT salen del crédito PUCV, por eso van junto a él. -->
          <b-form-group
            v-if="!matter.use_matter_values && usesPucvCredits"
            label-cols="0"
            label-cols-sm="3"
            label-for="credit"
            class="label"
          >
            <template #label>
              <div>
                {{
                  $getVisibleNames(
                    "manual.credits",
                    true,
                    "Créditos SCT Totales"
                  )
                }}
                <span>
                  <InfoTooltip
                    class="info-icon"
                    :tooltip_text="pucvSctFormulaText"
                  >
                  </InfoTooltip>
                </span>
              </div>
            </template>
            <div id="credit">
              <div class="d-flex">
                <b-badge class="credits-value mb-0" variant="light">
                  {{ creditSctChile }}
                </b-badge>
                <div
                  class="toggle-types noprint"
                  v-b-tooltip.v-secondary.hover="$t('reusable.common.credit')"
                >
                  <span
                    :class="{
                      'font-weight-bold': matter.use_automatic_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.automatic") }}</span
                  >

                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': matter.is_closed }"
                    @click="
                      () => {
                        if (!matter.is_closed) slotCheckCredits();
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !matter.use_automatic_credits,
                        'icon-check-disabled': matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !matter.use_automatic_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.planned") }}</span
                  >
                </div>
                <b-form-input
                  id="input-credits"
                  type="number"
                  min="0"
                  class="ml-2"
                  v-model="$v.matter.credits.$model"
                  :disabled="matter.use_automatic_credits || matter.is_closed"
                  :state="validateState('credits')"
                  aria-describedby="input-credits-feedback"
                  size="sm"
                ></b-form-input>
                <b-tooltip
                  :target="`input-credits`"
                  variant="secondary"
                  :noninteractive="true"
                >
                  <div v-if="matter.credits < 0">
                    {{ $t("reusable.common.greaterThanOrEqualToZero") }}
                  </div>
                </b-tooltip>
              </div>
            </div>
            <b-alert
              v-if="pucvSctMismatch"
              show
              variant="warning"
              class="pucv-credits-alert"
            >
              <b-icon icon="exclamation-triangle"></b-icon>
              {{ pucvSctMismatchText }}
            </b-alert>
          </b-form-group>
          <b-form-group
            v-if="!matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            :label="$t('matterProgram.matterForm.weeks').toUpperCase()"
            label-for="input-weeks"
            class="label my-2"
          >
            <b-form-input
              id="input-weeks"
              v-model="$v.matter.weeks.$model"
              :disabled="!allow_crud || matter.is_closed"
              type="number"
              min="0"
              :state="validateState('weeks')"
              v-b-tooltip.v-secondary.top.noninteractive="
                $t('matterProgram.matterForm.changeWeeksWarning', {
                  entity1: $getVisibleNames(
                    'manual.total_pedagogical_hours',
                    true,
                    'Total de Horas Pedagógicas'
                  ),
                  entity2: $getVisibleNames(
                    'manual.total_chronological_hours',
                    true,
                    'Total de Horas Cronológicas'
                  ),
                })
              "
              aria-describedby="input-weeks-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-weeks-feedback">{{
              $t("reusable.common.integerGreaterThanZero")
            }}</b-form-invalid-feedback>
          </b-form-group>
          <TimeAllocationComponent
            v-if="!matter.use_matter_values && disabled_component_hours_in_save"
            :egressProfileMatter="matter"
            :profileType="profileType"
            @updated="slotUpdateMatterHours"
          >
          </TimeAllocationComponent>
          <b-form-group
            v-if="
              !matter.use_matter_values &&
              showPedagogicalHours &&
              showChronologicalHours
            "
            label-cols="0"
            label-cols-sm="4"
            label-for="total_hours"
            class="label mb-0"
          >
            <template #label>
              <div>
                {{
                  $getVisibleNames(
                    "manual.total_hours_sum_to_chronological",
                    true,
                    "Total de Horas (Pedagógicas + Cronológicas)"
                  )
                }}
                <span>
                  <InfoTooltip
                    class="info-icon"
                    :tooltip_text="`${$getVisibleNames(
                      'manual.total_pedagogical_hours_to_chronological',
                      true,
                      'Total de Horas Pedagógicas (En Cronológicas)'
                    )} + ${$getVisibleNames(
                      'manual.total_chronological_hours',
                      true,
                      'Total de Horas Cronológicas'
                    )}`"
                  >
                  </InfoTooltip>
                </span>
              </div>
            </template>
            <div>
              <b-badge
                id="total_hours"
                class="total-hours-value mt-1"
                variant="light"
              >
                {{ totalHours }}
              </b-badge>
            </div>
          </b-form-group>
          <b-alert
            v-if="!matter.use_matter_values && pucvHoursExceeded"
            show
            variant="warning"
            class="pucv-credits-alert"
          >
            <b-icon icon="exclamation-triangle"></b-icon>
            {{ pucvHoursExceededText }}
          </b-alert>
          <b-form-group
            v-if="!matter.use_matter_values && !usesPucvCredits"
            label-cols="0"
            label-cols-sm="4"
            label-for="credit"
            class="label"
          >
            <template #label>
              <div>
                {{
                  $getVisibleNames(
                    "manual.credits",
                    true,
                    "Créditos SCT Totales"
                  )
                }}
                <span>
                  <InfoTooltip
                    class="info-icon"
                    :tooltip_text="`${$getVisibleNames(
                      'manual.total_hours_sum_to_chronological',
                      true,
                      'Total de Horas (Pedagógicas + Cronológicas)'
                    )}(${totalHours}) / ${$t(
                      'matterProgram.matterForm.hoursPerCredit'
                    )} ${$getVisibleNames(
                      'manual.credits',
                      true,
                      'Créditos SCT Totales'
                    )}(${institution.hours_per_credit})`"
                  >
                  </InfoTooltip>
                </span>
              </div>
            </template>
            <div id="credit">
              <div class="d-flex">
                <b-badge class="credits-value mb-0" variant="light">
                  {{ creditSctChile }}
                </b-badge>
                <div
                  class="toggle-types noprint"
                  v-b-tooltip.v-secondary.hover="$t('reusable.common.credit')"
                >
                  <span
                    :class="{
                      'font-weight-bold': matter.use_automatic_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.automatic") }}</span
                  >

                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': matter.is_closed }"
                    @click="
                      () => {
                        if (!matter.is_closed) slotCheckCredits();
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !matter.use_automatic_credits,
                        'icon-check-disabled': matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !matter.use_automatic_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.planned") }}</span
                  >
                </div>
                <b-form-input
                  id="input-credits"
                  type="number"
                  min="0"
                  class="ml-2"
                  v-model="$v.matter.credits.$model"
                  :disabled="matter.use_automatic_credits || matter.is_closed"
                  :state="validateState('credits')"
                  aria-describedby="input-credits-feedback"
                  size="sm"
                ></b-form-input>
                <b-tooltip
                  :target="`input-credits`"
                  variant="secondary"
                  :noninteractive="true"
                >
                  <div v-if="matter.credits < 0">
                    {{ $t("reusable.common.greaterThanOrEqualToZero") }}
                  </div>
                </b-tooltip>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            v-if="
              !matter.use_matter_values &&
              $hasInstitutionalCredits(institution) &&
              !usesPucvCredits
            "
            label-cols="0"
            label-cols-sm="4"
            label-for="input-institutional_credits"
            class="label"
          >
            <template v-slot:label>
              <!-- <b-icon
            v-b-tooltip.v-secondary.noninteractive="
              `Los cambios en este campo se verán reflejados en todas las ${$getVisibleNames(
                'mesh.egressprofilematter',
                true,
                'Asignaturas'
              ).toLowerCase()}`
            "
            icon="exclamation-triangle"
            style="margin-bottom: 0.1rem"
          ></b-icon> -->
              <!-- <span
                v-if="
                  !matter.is_closed &&
                  !(
                    (institution && institution.internal_use_id == 'duoc.cl')
                  )
                "
                v-b-tooltip.v-secondary.noninteractive="
                  $t('matterProgram.matterForm.changesReflectedTooltip2', {
                    entity: $getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toLowerCase()
                  })
                "
                >⚠️</span
              > -->
              {{
                $getVisibleNames(
                  "manual.institutional_credits",
                  false,
                  "Créditos Institucionales"
                )
              }}
              <span
                v-if="
                  profileType &&
                  $getInstitutionalCreditsFormula(institution) == 'duoc'
                "
              >
                <InfoTooltip
                  class="info-icon"
                  :tooltip_text="`${$getVisibleNames(
                    'manual.total_pedagogical_hours_to_chronological',
                    true,
                    'Total de Horas Pedagógicas (En Cronológicas)'
                  )}/9 => (${totalPedagogical})/9 = ${parseFloat(
                    (totalPedagogical / 9).toFixed(2)
                  )}`"
                >
                </InfoTooltip>
              </span>
              <span
                v-if="
                  profileType &&
                  $getInstitutionalCreditsFormula(institution) == 'unab'
                "
              >
                <InfoTooltip
                  class="info-icon"
                  :tooltip_text="`${$getVisibleNames(
                    'manual.total_pedagogical_hours',
                    true,
                    'Total de Horas Pedagógicas'
                  )}(${totalPedagogical})/${$t(
                    'matterProgram.matterForm.weeks'
                  )} + (${$getVisibleNames(
                    'manual.total_chronological_hours',
                    true,
                    'Total de Horas Cronológicas'
                  )}(${totalChronological})/${$t(
                    'matterProgram.matterForm.weeks'
                  )})*(60/${profileType.module_minutes})
                  `"
                >
                </InfoTooltip>
              </span>
            </template>
            <div id="credit">
              <div class="d-flex">
                <b-badge class="credits-value mb-0" variant="light">
                  {{ institutionalCredits }}
                </b-badge>
                <div
                  class="toggle-types noprint"
                  v-b-tooltip.v-secondary.hover="$t('reusable.common.credit')"
                >
                  <span
                    :class="{
                      'font-weight-bold':
                        matter.use_automatic_institutional_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.automatic") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': matter.is_closed }"
                    @click="
                      () => {
                        if (!matter.is_closed) slotCheckInstitutionalCredits();
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active':
                          !matter.use_automatic_institutional_credits,
                        'icon-check-disabled': matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold':
                        !matter.use_automatic_institutional_credits,
                    }"
                    >{{ $t("matterProgram.matterForm.planned") }}</span
                  >
                </div>
                <b-form-input
                  id="input-institutional_credits"
                  type="number"
                  min="0"
                  class="ml-2"
                  :disabled="
                    matter.use_automatic_institutional_credits ||
                    matter.is_closed
                  "
                  v-model="$v.matter.institutional_credits.$model"
                  :state="validateState('institutional_credits')"
                  aria-describedby="input-institutional_credits-feedback"
                  size="sm"
                ></b-form-input>
                <b-tooltip
                  :target="`input-institutional_credits`"
                  variant="secondary"
                  :noninteractive="true"
                >
                  <div v-if="matter.institutional_credits < 0">
                    {{ $t("reusable.common.greaterThanOrEqualToZero") }}
                  </div>
                </b-tooltip>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            v-if="!matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            :label="
              $t('matterProgram.matterForm.numberOf', {
                entity: $t('matterProgram.matterForm.students'),
              })
            "
            label-for="input-suggested-suggested_students"
            class="label my-2"
          >
            <b-form-input
              id="input-suggested-suggested_students"
              type="number"
              min="0"
              v-model="$v.matter.suggested_students.$model"
              :disabled="!allow_crud || matter.is_closed"
              :state="validateState('suggested_students')"
              aria-describedby="input-suggested-suggested_students-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback
              id="input-suggested-suggested_students-feedback"
              >{{
                $t("reusable.common.greaterThanOrEqualToZero")
              }}</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group
            v-if="!matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            :label="
              $t('matterProgram.matterForm.numberOf', {
                entity: $t('matterProgram.matterForm.teachers'),
              })
            "
            label-for="input-suggested-suggested_teachers"
            class="label my-2"
          >
            <b-form-input
              id="input-suggested-suggested_teachers"
              type="number"
              min="0"
              :disabled="!allow_crud || matter.is_closed"
              v-model="$v.matter.suggested_teachers.$model"
              :state="validateState('suggested_teachers')"
              aria-describedby="input-suggested-suggested_teachers-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback
              id="input-suggested-suggested_teachers-feedback"
              >{{
                $t("reusable.common.greaterThanOrEqualToZero")
              }}</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group
            v-if="!matter.use_matter_values"
            label-cols="0"
            label-cols-sm="3"
            :label="
              $t('matterProgram.matterForm.numberOf', {
                entity: $t('matterProgram.matterForm.assistants'),
              })
            "
            label-for="input-suggested-suggested_assistants"
            class="label my-2"
          >
            <b-form-input
              id="input-suggested-suggested_assistants"
              type="number"
              min="0"
              :disabled="!allow_crud || matter.is_closed"
              v-model="$v.matter.suggested_assistants.$model"
              :state="validateState('suggested_assistants')"
              aria-describedby="input-suggested-suggested_assistants-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback
              id="input-suggested-suggested_assistants-feedback"
              >{{
                $t("reusable.common.greaterThanOrEqualToZero")
              }}</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group
            label-cols="0"
            label-cols-sm="3"
            label-for="is_integrative"
            v-if="institution && institution.show_base_ra"
            class="label align-middle mb-2"
          >
            <template #label>
              <div class="weighing-label">
                <div class="label-content">
                  {{ $t("matterProgram.matterForm.shares") }}
                  {{ $getVisibleNames("teaching.basera", false, "RA Base") }}
                  <span>
                    <InfoTooltip
                      class="info-icon"
                      :tooltip_text="
                        $t(
                          'matterProgram.matterForm.allowRaAssignmentTooltip',
                          {
                            entity1: $getVisibleNames(
                              'teaching.basera',
                              false,
                              'RA Base'
                            ),
                            entity2: $getVisibleNames(
                              'mesh.egressprofilematter',
                              false,
                              'Asignatura'
                            ),
                          }
                        )
                      "
                    >
                    </InfoTooltip>
                  </span>
                </div>
              </div>
            </template>
            <div id="is_integrative" class="align-middle">
              <div class="d-flex">
                <div class="toggle-types noprint">
                  <span
                    :class="{
                      'font-weight-bold': matter.is_integrative,
                    }"
                  >
                    {{ $t("reusable.common.yes") }}
                  </span>
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': matter.is_closed }"
                    @click="
                      () => {
                        if (!matter.is_closed)
                          matter.is_integrative = !matter.is_integrative;
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !matter.is_integrative,
                        'icon-check-disabled': matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !matter.is_integrative,
                    }"
                    >{{ $t("reusable.common.no") }}</span
                  >
                </div>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            v-if="
              matter &&
              !matter.use_matter_values &&
              institution &&
              institution.internal_use_id == 'iacc.cl'
            "
            label-cols="0"
            label-cols-sm="3"
            label-for="is_exemptable"
            class="label align-middle mb-2"
          >
            <template #label>
              {{ $t("matterProgram.matterForm.isExemptable") }}
            </template>
            <div id="is_exemptable" class="align-middle">
              <div class="d-flex">
                <div class="toggle-types noprint">
                  <span
                    :class="{
                      'font-weight-bold': matter.is_exemptable,
                    }"
                    >{{ $t("reusable.common.yes") }}</span
                  >
                  <b-button
                    class="check-type"
                    :class="{ 'check-type-disabled': matter.is_closed }"
                    @click="
                      () => {
                        if (!matter.is_closed)
                          matter.is_exemptable = !matter.is_exemptable;
                      }
                    "
                    variant="primary"
                  >
                    <b-icon
                      icon="circle-fill"
                      class="icon-check"
                      :class="{
                        'icon-check-active': !matter.is_exemptable,
                        'icon-check-disabled': matter.is_closed,
                      }"
                      scale="0.7"
                    ></b-icon>
                  </b-button>
                  <span
                    :class="{
                      'font-weight-bold': !matter.is_exemptable,
                    }"
                    >{{ $t("reusable.common.no") }}</span
                  >
                </div>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            v-if="!isNaN(old_matter.id) && matter.use_matter_values"
            label-for="input-modification-date"
            label-cols="0"
            label-cols-sm="0"
            class="p-0 m-0 mt-2"
          >
            <ModificationDate :Information="old_matter"></ModificationDate>
          </b-form-group>
          <b-form-group
            v-if="!isNaN(matter.id) && !matter.use_matter_values"
            label-for="input-modification-date"
            label-cols="0"
            label-cols-sm="0"
            class="p-0 m-0 mt-2"
          >
            <ModificationDate :Information="matter"></ModificationDate>
          </b-form-group>
          <template v-if="isClosedMatter && !isNaN(matter.id)">
            <!-- v-b-tooltip.v-secondary.noninteractive="
                    `${
                      !theTestsHaveSomeErrors || (matter && matter.is_closed)
                        ? $t('matterProgram.matterForm.changeStatusTooltip', {
                            entity: $getVisibleNames(
                              'mesh.egressprofilematter',
                              false,
                              'Asignatura'
                            )
                          })
                        : ''
                    }`
                  " -->
            <div class="text-right mb-3 mr-1">
              <div class="btn-close-matter">
                <b-button
                  class="noprint"
                  size="sm"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('matterProgram.matterForm.changeStatusTooltip', {
                      entity: $getVisibleNames(
                        'mesh.egressprofilematter',
                        false,
                        'Asignatura'
                      ),
                    })
                  "
                  @click="changeStateMatter()"
                >
                  <!-- :disabled="
                    theTestsHaveSomeErrors && matter && !matter.is_closed
                  " -->
                  <template v-if="matter && matter.is_closed">
                    {{ $t("reusable.common.open") }}
                    {{
                      $getVisibleNames(
                        "mesh.egressprofilematter",
                        false,
                        "Asignatura"
                      )
                    }}
                    <b-icon
                      class="btn-actions"
                      icon="lock-fill"
                      scale="1"
                    ></b-icon>
                  </template>
                  <template v-else>
                    {{ $t("reusable.common.close") }}
                    {{
                      $getVisibleNames(
                        "mesh.egressprofilematter",
                        false,
                        "Asignatura"
                      )
                    }}
                    <b-icon
                      class="btn-actions"
                      icon="unlock-fill"
                      scale="1"
                    ></b-icon>
                  </template>
                </b-button>
                <!--  v-if="
                    (theTestsHaveSomeErrors ||
                      theTestsNotYetClose ||
                      excludeECMicro.length > 0) &&
                    institution &&
                    institution.internal_use_id == 'duoc.cl' &&
                    matter &&
                    !matter.is_closed
                  " -->
                <span
                  v-if="
                    (theTestsHaveSomeErrors ||
                      theTestsNotYetClose ||
                      excludeECMicro.length > 0) &&
                    institution &&
                    institution.internal_use_id == 'duoc.cl' &&
                    matter
                  "
                  class="ml-2"
                >
                  <!-- no puede cerrarse dado que cuenta con algunos errores que se deben corregir. Para más información presione el botón. -->
                  <ButtonErrorInstrument
                    variant="danger"
                    :popover_text="
                      $t('matterProgram.matterForm.evaluationErrorsPopover', {
                        entity: $getVisibleNames(
                          'mesh.egressprofilematter',
                          false,
                          'Asignatura'
                        ),
                      })
                    "
                    :id_popover="`matter-${matter.id}`"
                    click_modal="new-evaluation-list-modal"
                  ></ButtonErrorInstrument>
                </span>
              </div>
            </div>
          </template>
        </div>
        <b-modal
          :id="`new-formation-line-modal`"
          :hide-footer="true"
          :title="
            $t('reusable.common.createModalTitle', {
              entity: $getVisibleNames(
                'mesh.formationline',
                false,
                'Línea De Formación'
              ),
            })
          "
          size="md"
        >
          <FormationLineForm
            v-if="career"
            :faculty_id="career.faculty"
            @created="slotCreatedFormationLine"
          ></FormationLineForm>
        </b-modal>
        <b-modal
          :id="`edit-formation-line-modal-${matter.formation_line}`"
          :hide-footer="true"
          :title="
            $t('reusable.common.editModalTitle', {
              entity: $getVisibleNames(
                'mesh.formationline',
                false,
                'Línea De Formación'
              ),
            })
          "
          size="md"
        >
          <FormationLineForm
            v-if="
              matter.formation_line != null &&
              formationLines.find((x) => x.id == matter.formation_line) &&
              career
            "
            :FormationLine="
              formationLines.find((x) => x.id == matter.formation_line)
            "
            :faculty_id="career.faculty"
            @updated="
              $bvModal.hide(
                `edit-formation-line-modal-${matter.formation_line}`
              )
            "
          ></FormationLineForm>
        </b-modal>
        <b-modal
          v-if="matter && matter.matter != null"
          :id="`new-evaluation-list-modal`"
          hide-footer
          size="xl"
          :title="$t('matterProgram.matterForm.informationToComplete')"
        >
          <InfoEvaluations
            :matter_id="matter.matter"
            :egress_profile_matter_id="matter.id"
            :MattersEvaluations="matters_evaluations"
            @fetch_matters_evaluations="
              (f_matters_evaluations) =>
                (matters_evaluations = f_matters_evaluations)
            "
            :matter_from_form="true"
            @close_modal="$bvModal.hide(`new-evaluation-list-modal`)"
          ></InfoEvaluations>
        </b-modal>
        <b-modal
          v-if="matter && matter.matter != null"
          :id="`new-evaluation-correct-list-modal`"
          hide-footer
          size="lg"
          :title="$t('matterProgram.matterForm.closedEvaluations')"
        >
          <InfoEvaluations
            :matter_id="matter.matter"
            :egress_profile_matter_id="matter.id"
            :is_valid="true"
            @close_modal="$bvModal.hide(`new-evaluation-correct-list-modal`)"
          ></InfoEvaluations>
        </b-modal>
      </b-tab>
      <b-tab
        v-if="institution && institution.internal_use_id == 'duoc.cl'"
        :disabled="isNaN(matter.id) && isNaN(old_matter.id)"
      >
        <template #title>
          {{ $t("matterProgram.matterForm.descriptors") }}
          <b-button
            v-if="
              !isNaN(matter.id) &&
              !old_matter.descriptors_locked_view &&
              !old_matter.is_closed &&
              isClosedOldMatterPartial
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t('matterProgram.matterForm.lockDescriptorsTooltip', {
                    entity: $getVisibleNames(
                      'manual.matter_program',
                      false,
                      'Programa de la Asignatura'
                    ),
                  })
                : '',
              html: true,
            }"
            @click="
              changeLockedMatter({
                descriptors_locked_view: !old_matter.descriptors_locked_view,
              })
            "
          >
            <b-icon-unlock-fill></b-icon-unlock-fill>
          </b-button>
          <b-button
            v-if="
              !isNaN(matter.id) &&
              old_matter.descriptors_locked_view &&
              !old_matter.is_closed
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t('matterProgram.matterForm.unlockDescriptorsTooltip', {
                    entity: $getVisibleNames(
                      'manual.matter_program',
                      false,
                      'Programa de la Asignatura'
                    ),
                  })
                : $t('matterProgram.matterForm.currentlyEntityLocked', {
                    entity: $t('matterProgram.matterForm.descriptors'),
                  }),
              html: true,
            }"
            @click="
              changeLockedMatter({
                descriptors_locked_view: !old_matter.descriptors_locked_view,
              })
            "
          >
            <b-icon-lock-fill></b-icon-lock-fill>
          </b-button>
        </template>
        <MatterDescriptorsContainer
          v-if="!isNaN(matter.id) && !isNaN(old_matter.id)"
          :oldMatter="old_matter"
          :matter="matter"
          :allows_crud="
            !old_matter.is_closed && !old_matter.descriptors_locked_view
          "
          :show_matter_descriptor="true"
          :can_update="can_update"
          :can_delete="can_delete"
        ></MatterDescriptorsContainer>
      </b-tab>
      <b-tab :disabled="isNaN(matter.id) && isNaN(old_matter.id)">
        <template #title>
          {{ $t("matterProgram.matterForm.teachingSupportResources") }}
          <b-button
            v-if="
              !isNaN(matter.id) &&
              !old_matter.education_technology_locked_view &&
              !old_matter.is_closed &&
              isClosedOldMatterPartial
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t('matterProgram.matterForm.lockTeachingSupportTooltip', {
                    entity: $getVisibleNames(
                      'manual.matter_program',
                      false,
                      'Programa de la Asignatura'
                    ),
                  })
                : '',
              html: true,
            }"
            @click="
              changeLockedMatter({
                education_technology_locked_view:
                  !old_matter.education_technology_locked_view,
              })
            "
          >
            <b-icon-unlock-fill></b-icon-unlock-fill>
          </b-button>
          <b-button
            v-if="
              !isNaN(matter.id) &&
              old_matter.education_technology_locked_view &&
              !old_matter.is_closed
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t('matterProgram.matterForm.unlockTeachingSupportTooltip', {
                    entity: $getVisibleNames(
                      'manual.matter_program',
                      false,
                      'Programa de la Asignatura'
                    ),
                  })
                : $t('matterProgram.matterForm.currentlyEntityLocked', {
                    entity: $t(
                      'matterProgram.matterForm.teachingSupportResources'
                    ),
                  }),
              html: true,
            }"
            @click="
              changeLockedMatter({
                education_technology_locked_view:
                  !old_matter.education_technology_locked_view,
              })
            "
          >
            <b-icon-lock-fill></b-icon-lock-fill>
          </b-button>
        </template>
        <TeachingSupportResourcesComponent
          v-if="!isNaN(matter.id) && !isNaN(old_matter.id)"
          :oldMatter="old_matter"
          :allows_crud="
            !old_matter.is_closed &&
            !old_matter.education_technology_locked_view
          "
          :supportResources="[]"
          :matter_form_view="true"
          :filter_object_in_view="
            institution && institution.internal_use_id == 'duoc.cl'
              ? true
              : false
          "
          :can_update="can_update"
          :can_delete="can_delete"
          @change_teaching_support_resources="
            $emit('change_teaching_support_resources')
          "
        ></TeachingSupportResourcesComponent>
      </b-tab>
      <b-tab :disabled="isNaN(matter.id) && isNaN(old_matter.id)">
        <template #title>
          {{ $t("matterProgram.matterForm.bibliographicResources") }}
          <b-button
            v-if="
              !isNaN(matter.id) &&
              !old_matter.bibliography_locked_view &&
              !old_matter.is_closed &&
              isClosedOldMatterPartial
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t(
                    'matterProgram.matterForm.lockBibliographicResourcesTooltip',
                    {
                      entity: $getVisibleNames(
                        'manual.matter_program',
                        false,
                        'Programa de la Asignatura'
                      ),
                    }
                  )
                : '',
              html: true,
            }"
            @click="
              changeLockedMatter({
                bibliography_locked_view: !old_matter.bibliography_locked_view,
              })
            "
          >
            <b-icon-unlock-fill></b-icon-unlock-fill>
          </b-button>
          <b-button
            v-if="
              !isNaN(matter.id) &&
              old_matter.bibliography_locked_view &&
              !old_matter.is_closed
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t(
                    'matterProgram.matterForm.unlockBibliographicResourcesTooltip',
                    {
                      entity: $getVisibleNames(
                        'manual.matter_program',
                        false,
                        'Programa de la Asignatura'
                      ),
                    }
                  )
                : $t('matterProgram.matterForm.currentlyEntityLocked', {
                    entity: $t(
                      'matterProgram.matterForm.bibliographicResources'
                    ),
                  }),
              html: true,
            }"
            @click="
              changeLockedMatter({
                bibliography_locked_view: !old_matter.bibliography_locked_view,
              })
            "
          >
            <b-icon-lock-fill></b-icon-lock-fill>
          </b-button>
        </template>
        <BibliographicResourcesComponent
          v-if="!isNaN(matter.id) && !isNaN(old_matter.id)"
          :oldMatter="old_matter"
          :matter_form_view="true"
          :matter="matter"
          :allows_crud="
            !old_matter.is_closed && !old_matter.bibliography_locked_view
          "
          :can_update="can_update"
          :can_delete="can_delete"
          :filter_object_in_view="
            institution && institution.internal_use_id == 'duoc.cl'
              ? true
              : false
          "
          @change_bibliographic_resource="
            $emit('change_bibliographic_resource')
          "
        ></BibliographicResourcesComponent>
      </b-tab>
      <b-tab :disabled="isNaN(matter.id) && isNaN(old_matter.id)">
        <template #title>
          {{ $t("matterProgram.matterForm.teacherProfiles") }}
          <b-button
            v-if="
              !isNaN(matter.id) &&
              !old_matter.teacher_profile_locked_view &&
              !old_matter.is_closed &&
              isClosedOldMatterPartial
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t('matterProgram.matterForm.lockTeacherProfilesTooltip', {
                    entity: $getVisibleNames(
                      'manual.matter_program',
                      false,
                      'Programa de la Asignatura'
                    ),
                  })
                : '',
              html: true,
            }"
            @click="
              changeLockedMatter({
                teacher_profile_locked_view:
                  !old_matter.teacher_profile_locked_view,
              })
            "
          >
            <b-icon-unlock-fill></b-icon-unlock-fill>
          </b-button>
          <b-button
            v-if="
              !isNaN(matter.id) &&
              old_matter.teacher_profile_locked_view &&
              !old_matter.is_closed
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t('matterProgram.matterForm.unlockTeacherProfilesTooltip', {
                    entity: $getVisibleNames(
                      'manual.matter_program',
                      false,
                      'Programa de la Asignatura'
                    ),
                  })
                : $t('matterProgram.matterForm.currentlyEntityLocked', {
                    entity: $t('matterProgram.matterForm.teacherProfiles'),
                  }).toUpperCase(),
              html: true,
            }"
            @click="
              changeLockedMatter({
                teacher_profile_locked_view:
                  !old_matter.teacher_profile_locked_view,
              })
            "
          >
            <b-icon-lock-fill></b-icon-lock-fill>
          </b-button>
        </template>
        <TeachingProfileComponent
          v-if="!isNaN(matter.id) && !isNaN(old_matter.id)"
          :oldMatter="old_matter"
          :matter_form_view="true"
          :allows_crud="
            !old_matter.is_closed && !old_matter.teacher_profile_locked_view
          "
          :matter="matter"
          :can_update="can_update"
          :can_delete="can_delete"
          @change_teaching_profile="$emit('change_teaching_profile')"
        ></TeachingProfileComponent
      ></b-tab>
      <b-tab :disabled="isNaN(matter.id) && isNaN(old_matter.id)">
        <template #title>
          {{ $t("matterProgram.matterForm.assistantProfiles") }}
          <b-button
            v-if="
              !isNaN(matter.id) &&
              !old_matter.assistant_profile_locked_view &&
              !old_matter.is_closed &&
              isClosedOldMatterPartial
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t('matterProgram.matterForm.lockAssistantProfilesTooltip', {
                    entity: $getVisibleNames(
                      'manual.matter_program',
                      false,
                      'Programa de la Asignatura'
                    ),
                  })
                : '',
              html: true,
            }"
            @click="
              changeLockedMatter({
                assistant_profile_locked_view:
                  !old_matter.assistant_profile_locked_view,
              })
            "
          >
            <b-icon-unlock-fill></b-icon-unlock-fill>
          </b-button>
          <b-button
            v-if="
              !isNaN(matter.id) &&
              old_matter.assistant_profile_locked_view &&
              !old_matter.is_closed
            "
            variant="none"
            size="sm"
            class="btn-unlock mb-1"
            v-b-tooltip.top.noninteractive.v-secondary="{
              title: isClosedOldMatterPartial
                ? $t(
                    'matterProgram.matterForm.unlockAssistantProfilesTooltip',
                    {
                      entity: $getVisibleNames(
                        'manual.matter_program',
                        false,
                        'Programa de la Asignatura'
                      ),
                    }
                  )
                : $t('matterProgram.matterForm.currentlyEntityLocked', {
                    entity: $t('matterProgram.matterForm.assistantProfiles'),
                  }),
              html: true,
            }"
            @click="
              changeLockedMatter({
                assistant_profile_locked_view:
                  !old_matter.assistant_profile_locked_view,
              })
            "
          >
            <b-icon-lock-fill></b-icon-lock-fill>
          </b-button>
        </template>
        <AssistantProfileComponent
          v-if="!isNaN(matter.id) && !isNaN(old_matter.id)"
          :oldMatter="old_matter"
          :matter_form_view="true"
          @change_assistant_profile="$emit('change_assistant_profile')"
          :allows_crud="
            !old_matter.is_closed && !old_matter.assistant_profile_locked_view
          "
          :can_update="can_update"
          :can_delete="can_delete"
        ></AssistantProfileComponent
      ></b-tab>
      <!-- @update_old_matter="slotUpdateOldMatter" -->
    </b-tabs>
    <!-- Comienza la sección de los botones -->
    <div class="row">
      <div
        v-if="show_delete_button && !matter.is_closed"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="askForDeleteMatter"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="mr-1" size="sm" :disabled="saving" @click="save">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{
            saving
              ? $t("reusable.common.saving")
              : $t("reusable.common.save")
          }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  minValue,
  numeric,
} from "vuelidate/lib/validators";
import { generateUniqueId, toast } from "@/utils/utils";
import {
  pucvSctCredits,
  pucvWeeklyHours,
  pucvMaxSemesterHours,
  toPucvPedagogicalHours,
} from "@/utils/pucvCredits";
import "vue-multiselect/dist/vue-multiselect.min.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "MatterForm",
  mixins: [validationMixin],
  components: {
    vSelect,
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    // GenericBTable: () => import("@/components/reusable/GenericBTable"),
    NewGenericBTable: () => import("@/components/reusable/NewGenericBTable"),
    TimeAllocationComponent: () => import("./TimeAllocationComponent.vue"),
    // OldMatterForm: () => import("./OldMatterForm.vue"),
    InfoTooltip: () => import("@/components/reusable/InfoTooltip"),
    InfoPopover: () => import("@/components/reusable/InfoPopover"),
    InfoPopoverComparison: () =>
      import("@/components/reusable/InfoPopoverComparison"),
    ButtonErrorInstrument: () =>
      import("@/components/reusable/ButtonErrorInstrument"),
    FormationLineForm: () =>
      import(
        "@/components/mesh/CurricularResources/FormationLine/FormationLineForm"
      ),
    MatterTimeAllocationComponent: () =>
      import("./MatterTimeAllocationComponent.vue"),
    TeachingProfileComponent: () =>
      import(
        "@/components/teaching/MatterProgram/Components/TeachingProfileComponent.vue"
      ),
    AssistantProfileComponent: () =>
      import(
        "@/components/teaching/MatterProgram/Components/AssistantProfileComponent.vue"
      ),
    TeachingSupportResourcesComponent: () =>
      import(
        "@/components/teaching/MatterProgram/Components/TeachingSupportResourcesComponent.vue"
      ),
    BibliographicResourcesComponent: () =>
      import(
        "@/components/teaching/MatterProgram/Components/BibliographicResourcesComponent.vue"
      ),
    MatterDescriptorsContainer: () =>
      import("@/components/mesh/Matrix2/MatterDescriptorsContainer.vue"),
    InfoEvaluations: () =>
      import("@/components/new-evaluations/Evaluation/InfoEvaluations.vue"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    MatterStudyEnvironment: () =>
      import("@/components/mesh/Matrix2/MatterStudyEnvironment"),
    // ResizeAuto: () => import("@/components/reusable/ResizeAuto"),
  },
  props: {
    Matter: {
      type: Object,
    },
    egress_profile_id: {
      type: Number,
      required: true,
    },
    courses_wrapper_id: {
      default: null,
    },
    show_title: {
      type: Boolean,
      default: false,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
    tabs_mode: {
      type: Boolean,
      default: true,
    },
    allow_crud: {
      type: Boolean,
      default: true,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disabled_component_hours_in_save: true,
      saving_matter_hours: false,
      saving_old_matter_hours: false,
      matter: {
        id: this.Matter ? this.Matter.id : generateUniqueId(),
        code: this.Matter ? this.Matter.code : "",
        order: this.Matter ? this.Matter.order : 100,
        plan_level: this.Matter ? this.Matter.plan_level : 1,
        strategy: this.Matter ? this.Matter.strategy : "",
        toggle_in_weeks: this.Matter ? this.Matter.toggle_in_weeks : false,
        study_environments: this.Matter ? this.Matter.study_environments : [],
        suggested_students: this.Matter ? this.Matter.suggested_students : 0,
        suggested_teachers: this.Matter ? this.Matter.suggested_teachers : 0,
        suggested_assistants: this.Matter
          ? this.Matter.suggested_assistants
          : 0,
        regime: this.Matter ? this.Matter.regime : null,
        is_integrative: this.Matter ? this.Matter.is_integrative : false,
        is_exemptable: this.Matter ? this.Matter.is_exemptable : false,
        formation_area: this.Matter ? this.Matter.formation_area : null,
        matter: this.Matter ? this.Matter.matter : null,
        formation_line: this.Matter ? this.Matter.formation_line : null,
        matter_types: this.Matter ? this.Matter.matter_types : [],
        matter_contributions: this.Matter
          ? this.Matter.matter_contributions
          : [],
        modalities: this.Matter ? this.Matter.modalities : [],
        egress_profile: this.Matter
          ? this.Matter.egress_profile
          : this.egress_profile_id,
        prerequisites: this.Matter ? this.Matter.prerequisites : [],
        competences: this.Matter ? this.Matter.competences : [],
        capacities: this.Matter ? this.Matter.capacities : [],
        campuses: this.Matter ? this.Matter.campuses : [],
        weeks: this.Matter ? this.Matter.weeks : 0,
        credits: this.Matter ? this.Matter.credits : 0,
        institutional_credits: this.Matter
          ? this.Matter.institutional_credits
          : 0,
        use_matter_values: this.Matter ? this.Matter.use_matter_values : true,
        use_automatic_credits: this.Matter
          ? this.Matter.use_automatic_credits
          : true,
        use_automatic_institutional_credits: this.Matter
          ? this.Matter.use_automatic_institutional_credits
          : true,
        is_closed: this.Matter ? this.Matter.is_closed : false,
        updated_by: this.Matter ? this.Matter.updated_by : null,
        update_date: this.Matter ? this.Matter.update_date : null,
      },
      old_matter: {
        id: this.Matter ? this.Matter.matter : generateUniqueId(),
        name: "",
        code: "",
        automatic_achievement_weighing: true,
        modalities: [],
        study_environments: [],
        weeks: 0,
        publish_date: null,
        credits: 0,
        institutional_credits: 0,
        is_elective: false,
        is_capstone_course: false,
        toggle_in_weeks: false,
        suggested_students: 0,
        suggested_teachers: 0,
        suggested_assistants: 0,
        is_closed: false,
        is_exemptable: false,
        matter_category: null,
        default_language: null,
        matter_types: [],
        use_automatic_credits: true,
        use_automatic_institutional_credits: true,
        distribution_teaching_profile_hours: true,
        learning_result_locked_view: false,
      },
      show_err_trasnversal_matter: false,
      finished_mounted: false,
      matter_hours: [],
      old_matter_hours: [],
      input_search: "",
      step_matter: false,
      reload_matter_time_allocation: 0,
      tabs_index: 0,
      // languages: [],
      matter_codes: [],
      sortBy: "",
      sortDesc: false,
      tab_index: 0,
      matters_evaluations: [],
      verified_code: this.Matter ? true : false,
      code_used: false,
      found_matter_id_by_code: null,
      found_matter_name_by_code: "",
      saving: false,
    };
  },
  validations: {
    matter: {
      matter: {},
      order: {
        required,
        numeric,
        minValue: minValue(1),
      },
      regime: {
        required,
      },
      study_environments: {},
      suggested_students: {},
      suggested_teachers: {},
      suggested_assistants: {},
      formation_area: {},
      formation_line: {},
      matter_types: {},
      matter_contributions: {},
      modalities: {},
      is_integrative: {},
      is_exemptable: {},
      plan_level: {
        required,
        numeric,
        minValue: minValue(1),
        maxValue() {
          if (
            parseFloat(this.matter.plan_level) <=
            parseFloat(this.egressProfile.semester_amount)
          )
            return true;
          else return false;
        },
      },
      weeks: {
        required,
        minValue: minValue(1),
      },
      credits: {
        required,
        minValue: minValue(0),
      },
      institutional_credits: {
        minValue: minValue(0),
      },
    },
    old_matter: {
      name: {
        required,
        minLength: minLength(1),
        isUnique() {
          return (
            this.SameEgressProfileMatterName &&
            !this.show_err_trasnversal_matter
          );
        },
      },
      code: {
        isUnique() {
          if (
            this.old_matter.code == "" ||
            (this.verified_code == true &&
              this.code_used == false &&
              this.old_matter.code.length > 0)
          )
            return true;
          else return false;
        },
      },
      modalities: {},
      study_environments: {},
      weeks: {
        required,
        minValue: minValue(1),
      },
      credits: { minValue: minValue(0) },
      institutional_credits: {
        minValue: minValue(0),
      },
      publish_date: {},
      suggested_students: {},
      suggested_teachers: {},
      suggested_assistants: {},
      matter_category: {},
      is_exemptable: {},
      matter_types: {},
    },
    validationGroup: ["matter", "old_matter"],
  },
  computed: {
    ...mapGetters({
      cycles: names.CYCLES,
      regimes: names.REGIMES,
      formationAreas: names.FORMATION_AREAS,
      formationLines: names.FORMATION_LINES,
      matterCategories: names.MATTER_CATEGORIES,
      matterTypes: names.MATTER_TYPES,
      profile_types: names.PROFILE_TYPES,
      matterContributions: names.MATTER_CONTRIBUTIONS,
      modalities: names.MODALITIES,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      competences: names.COMPETENCES,
      studyEnvironments: names.STUDY_ENVIRONMENTS,
      institution: "getInstitution",
      user: "getUser",
      matters: names.MATTERS,
      campuses: names.CAMPUSES,
      careers: names.CAREERS,
      egress_profiles: names.EGRESS_PROFILES,
      ep_matter_time_allocations: names.EP_MATTER_TIME_ALLOCATIONS,
      time_allocations: names.TIME_ALLOCATIONS,
      courses_wrapper: names.COURSES_WRAPPER,
      faculties: names.FACULTIES,
      evaluations: names.NEW_EVALUATIONS,
      tests: names.NEW_TESTS,
      evaluationCriterias: names.EVALUATION_CRITERIAS,
      studyUnits: names.STUDY_UNITS,
      languages: names.LANGUAGES,
    }),
    flagMap() {
      return {
        es: require("@/assets/es_icon.png"),
        en: require("@/assets/us_icon.png"),
      };
    },
    matterLanguages() {
      return this.languages.filter((x) => x.is_active_matter_view);
    },
    // El Tipo de Asignatura se edita en la Asignatura del Perfil salvo que use los
    // valores de la asignatura base; en PUCV varía por plan, así que va siempre en el perfil.
    editsEgressProfileMatterTypes() {
      return (
        !this.matter.use_matter_values ||
        this.$usesEgressProfileMatterTypes(this.institution)
      );
    },
    selectedStudyEnvironmentsMatter() {
      // Filtra solo los ambientes que están seleccionados en matter
      if (!this.matter.study_environments) return [];
      return this.studyEnvironments.filter((env) =>
        this.matter.study_environments.includes(env.id)
      );
    },
    selectedStudyEnvironmentsOldMatter() {
      // Filtra solo los ambientes que están seleccionados en old_matter
      if (!this.old_matter.study_environments) return [];
      return this.studyEnvironments.filter((env) =>
        this.old_matter.study_environments.includes(env.id)
      );
    },
    linkEntityPopoverSections() {
      const epmName = this.$getVisibleNames(
        "mesh.egressprofilematter",
        false,
        "Asignatura"
      );
      const epName = this.$getVisibleNames(
        "mesh.egressprofile",
        false,
        "Perfil de Egreso"
      );
      const baseName = this.$getVisibleNames(
        "teaching.matter",
        false,
        "Asignatura Base"
      );
      const epmPluralLower = this.$getVisibleNames(
        "mesh.egressprofilematter",
        true,
        "Asignaturas"
      ).toLowerCase();
      return [
        {
          title: this.$t("matterProgram.matterForm.linkEntityLinkedTitle"),
          header_icon: "check-circle-fill",
          header_color: "#28a745",
          description: this.$t(
            "matterProgram.matterForm.linkEntityLinkedDesc",
            { entity1: epmName, entity2: epName, entity3: baseName }
          ),
          items: this.$t(
            "matterProgram.matterForm.linkEntityLinkedItems"
          ).split("|"),
          alert: this.$t("matterProgram.matterForm.linkEntityLinkedWarning", {
            entity: epmPluralLower,
          }),
          alert_icon: "exclamation-triangle-fill",
          alert_type: "warning",
        },
        {
          title: this.$t("matterProgram.matterForm.linkEntityIndependentTitle"),
          header_icon: "x-circle-fill",
          header_color: "#dc3545",
          description: this.$t(
            "matterProgram.matterForm.linkEntityIndependentDesc",
            { entity1: epmName, entity2: epName }
          ),
          items: this.$t(
            "matterProgram.matterForm.linkEntityIndependentItems"
          ).split("|"),
          alert: this.$t("matterProgram.matterForm.linkEntityIndependentInfo", {
            entity1: epmName.toLowerCase(),
            entity2: epName,
          }),
          alert_icon: "shield-check",
          alert_type: "success",
        },
      ];
    },
    preservedItems() {
      const items = [];
      if (this.institution && this.institution.show_ra_macro) {
        items.push(this.$getVisibleNames("teaching.ramacro", true, "RA Macro"));
      }
      if (this.institution && this.institution.show_competence_unit) {
        items.push(
          this.$getVisibleNames(
            "teaching.tempcompetenceunit",
            true,
            "Unidades de Competencia"
          )
        );
      }
      items.push(
        this.$getVisibleNames(
          "teaching.ramicro",
          true,
          "Resultados de Aprendizaje"
        )
      );
      items.push(
        this.$getVisibleNames(
          "manual.indicador_de_logro",
          false,
          "Indicador de Logro"
        )
      );
      items.push(
        this.$getVisibleNames("teaching.studyunitcontent", true, "Contenidos")
      );
      if (this.institution && this.institution.internal_use_id != "duoc.cl") {
        items.push(
          this.$getVisibleNames(
            "mesh.methodologicalstrategy",
            true,
            "Estrategias Metodológicas"
          )
        );
      }
      items.push(
        this.$getVisibleNames(
          "teaching.learningexperience",
          true,
          "Experiencias de Aprendizaje"
        )
      );
      items.push(this.$t("matterProgram.matterForm.teachingSupportResources"));
      items.push(this.$t("matterProgram.matterForm.bibliographicResources"));
      items.push(this.$t("matterProgram.matterForm.teacherProfiles"));
      items.push(this.$t("matterProgram.matterForm.assistantProfiles"));
      return items;
    },
    preservedItemsJoined() {
      const items = this.preservedItems;
      if (items.length <= 1) return items.join("");
      const conjunction = this.$t("reusable.common.and");
      return (
        items.slice(0, -1).join(", ") +
        " " +
        conjunction +
        " " +
        items[items.length - 1]
      );
    },
    showPedagogicalHours() {
      return (
        this.time_allocations.filter((x) => x.uses_module_minutes == true)
          .length > 0
      );
    },
    showChronologicalHours() {
      return (
        this.time_allocations.filter((x) => x.uses_module_minutes == false)
          .length > 0
      );
    },
    egressProfilesMatters() {
      return this.egress_profiles_matters.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
    },
    isClosedMatter() {
      if (
        (this.user && this.user.is_superuser) ||
        (this.matter &&
          this.$hasObjectPermission(
            "special.close_egress_profile_matter",
            "special",
            this.matter.id
          ) &&
          !this.matter.is_closed) ||
        (this.matter &&
          this.$hasObjectPermission(
            "special.open_egress_profile_matter",
            "special",
            this.matter.id
          ) &&
          this.matter.is_closed)
      ) {
        return true;
      } else return false;
    },
    isClosedOldMatter() {
      if (
        (this.user && this.user.is_superuser) ||
        (this.old_matter &&
          this.$hasObjectPermission(
            "special.close_base_matter",
            "special",
            this.old_matter.id
          ) &&
          !this.old_matter.is_closed) ||
        (this.old_matter &&
          this.$hasObjectPermission(
            "special.open_base_matter",
            "special",
            this.old_matter.id
          ) &&
          this.old_matter.is_closed)
      ) {
        return true;
      } else return false;
    },
    isClosedOldMatterPartial() {
      if (
        (this.user && this.user.is_superuser) ||
        (this.old_matter &&
          this.$hasObjectPermission(
            "special.open_base_matter_partial_locks",
            "special",
            this.old_matter.id
          ) &&
          !this.old_matter.is_closed) ||
        (this.old_matter &&
          this.$hasObjectPermission(
            "special.close_base_matter_partial_locks",
            "special",
            this.old_matter.id
          ) &&
          !this.old_matter.is_closed)
      ) {
        return true;
      } else return false;
    },
    egressProfile() {
      if (!this.egress_profile_id) return [];
      return this.egress_profiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    faculty() {
      if (!this.career) return null;
      return this.faculties.find((x) => x.id == this.career.faculty);
    },
    coursesWrapper() {
      if (!this.courses_wrapper_id) return null;
      return this.courses_wrapper.find((x) => x.id == this.courses_wrapper_id);
    },
    coursesWrappers() {
      if (!this.egress_profile_id) return [];
      return this.courses_wrapper.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
    },
    regimesList() {
      if (!this.egressProfile) return [];
      //Bimestral(2) - Trimestral(3) - Semestral(6)
      const months_amount_egress_profile = this.regimes.find(
        (x) => x.id == this.egressProfile.regime
      );
      if (months_amount_egress_profile) {
        if (months_amount_egress_profile.months_amount == 6)
          return this.regimes
            .filter((x) => [6, 12].includes(x.months_amount))
            .sort((a, b) => b.months_amount - a.months_amount);
        else if (months_amount_egress_profile.months_amount == 3)
          return this.regimes
            .filter((x) => [3, 6].includes(x.months_amount))
            .sort((a, b) => b.months_amount - a.months_amount);
        else if (months_amount_egress_profile.months_amount == 2)
          return this.regimes
            .filter((x) => [2, 3].includes(x.months_amount))
            .sort((a, b) => b.months_amount - a.months_amount);
      } else
        return this.regimes
          .filter((x) => [6, 12].includes(x.months_amount))
          .sort((a, b) => b.months_amount - a.months_amount);
      return [];
    },
    fieldsMatterCode() {
      return [
        { key: "selected", label: "", display_column: true },
        {
          key: "name",
          label: this.$t("reusable.common.name"),
          display_column: true,
        },
        {
          key: "code",
          label: String(
            this.$getVisibleNames("manual.matter_code", false, "Código")
          ),
          display_column: true,
        },
        {
          key: "modalities",
          label: String(
            this.$getVisibleNames(
              "mesh.modality",
              false,
              "Modalidad de Asignatura"
            )
          ),
          display_column: true,
        },
        {
          key: "formation_area",
          label: String(
            this.$getVisibleNames(
              "mesh.formationarea",
              false,
              "Área De Formación"
            )
          ),
          display_column: true,
        },
      ].filter(
        (field) =>
          field.key != "formation_area" ||
          !this.$hidesFormationArea(this.institution)
      );
    },
    SameEgressProfileMatterName() {
      if (!this.old_matter) return false;

      //Caso cuando no es Transversal
      if (this.faculty && this.faculty.duoc_has_transversal_matters == false) {
        const same_matter_id = this.matter_codes
          .filter(
            (matter) =>
              this.$equals(this.old_matter.name, matter.name) &&
              this.old_matter.id != matter.id
          )
          .map((x) => x.id);
        const egress_profile_matter = this.egress_profiles_matters.find(
          (x) =>
            same_matter_id.includes(x.matter) &&
            this.old_matter.id != x.matter &&
            x.egress_profile == this.egress_profile_id &&
            // Exclude the egress profile matter currently being edited: when
            // replacing it with another base matter that shares the name, the
            // record being replaced must not count as a name conflict.
            x.id != this.matter.id
        );
        if (egress_profile_matter) return false;
      }
      return true;
    },
    SameMatterName() {
      if (!this.old_matter) return false;
      const SameMatterName = this.matter_codes.find(
        (matter) =>
          this.$equals(this.old_matter.name, matter.name) &&
          this.old_matter.id != matter.id
      );
      if (SameMatterName) return false;
      return true;
    },
    // SameMatterCode() {
    //   if (!this.old_matter) return false;
    //   const SameMatterCode = this.matter_codes.find(
    //     (matter) =>
    //       this.$equals(this.old_matter.code, matter.code) &&
    //       this.old_matter.id != matter.id
    //   );
    //   if (SameMatterCode) return false;
    //   return true;
    // },
    profileType() {
      if (!this.egressProfile) return null;
      return this.profile_types.find(
        (x) => x.id == this.egressProfile.egress_profile_type
      );
    },
    formationLinesList() {
      if (!this.career) return [];
      return this.formationLines.filter(
        (x) =>
          x.faculties.includes(this.career.faculty) ||
          this.matter.formation_line == x.id
      );
    },
    orderSugested() {
      let list = this.egress_profiles_matters.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
      if (list.length == 0) {
        list = this.egress_profiles_matters.filter(
          (x) => x.egress_profile == this.egress_profile_id
        );
      }
      let order = 0;
      list.forEach((x) => {
        if (x.order > order) {
          order = x.order;
        }
      });
      order += 1;
      return order;
    },
    totalPedagogical() {
      let count = 0;
      if (!this.matter.use_matter_values)
        this.matter_hours
          .filter((x) => x.uses_module_minutes == true)
          .forEach((element) => {
            if (
              element.counts_towards_credits &&
              element.hours &&
              element.hours >= 0
            ) {
              count += parseFloat(element.hours);
            }
          });
      else
        this.old_matter_hours
          .filter((x) => x.uses_module_minutes == true)
          .forEach((element) => {
            if (
              element.counts_towards_credits &&
              element.hours &&
              element.hours >= 0
            ) {
              count += parseFloat(element.hours);
            }
          });
      return count;
    },
    totalChronological() {
      let count = 0;
      if (!this.matter.use_matter_values)
        this.matter_hours
          .filter((x) => x.uses_module_minutes == false)
          .forEach((element) => {
            if (
              element.counts_towards_credits &&
              element.hours &&
              element.hours >= 0
            ) {
              count += parseFloat(element.hours);
            }
          });
      else
        this.old_matter_hours
          .filter((x) => x.uses_module_minutes == false)
          .forEach((element) => {
            if (
              element.counts_towards_credits &&
              element.hours &&
              element.hours >= 0
            ) {
              count += parseFloat(element.hours);
            }
          });
      return count;
    },
    totalHours() {
      if (!this.profileType) return 0;
      const total_hours =
        this.totalPedagogical * (this.profileType.module_minutes / 60) +
        this.totalChronological;
      if (
        this.institution &&
        parseInt(this.institution.hour_decimal_places) === 0 &&
        total_hours
      )
        return parseFloat(Math.round(total_hours));
      else
        return total_hours
          ? parseFloat(
              total_hours.toFixed(
                this.institution &&
                  parseInt(this.institution.hour_decimal_places) > 0
                  ? parseInt(this.institution.hour_decimal_places)
                  : 2
              )
            )
          : 0;
    },
    creditSctChile() {
      // En PUCV los SCT salen del crédito PUCV (×1.5) y no de las horas.
      if (this.usesPucvCredits) return this.pucvExpectedSct;
      if (!this.profileType) return 0;
      const credits = Math.round(
        this.totalHours / parseFloat(this.institution.hours_per_credit)
      );
      return credits ? credits : 0;
    },
    institutionalCredits() {
      // La fórmula de cada institución se define en institutional_credits_formulas (main.js).
      const formula = this.$getInstitutionalCreditsFormula(this.institution);
      if (formula == "unab") {
        // Formula de los créditos institucionales que ocupa UNAB
        const matter = !this.matter.use_matter_values
          ? this.matter
          : this.old_matter;
        if (matter.weeks == 0) return 0;
        const weeks = matter.weeks;
        const total_pedagogical_hours = this.totalPedagogical / weeks;
        const total_chronological_hours = this.totalChronological / weeks;
        if (this.profileType)
          return Math.round(
            total_pedagogical_hours +
              total_chronological_hours * (60 / this.profileType.module_minutes)
          );
        else return 0;
      } else if (formula == "duoc") {
        // Formula de los créditos institucionales que ocupa DUOC
        const total_pedagogical_hours = this.totalPedagogical;
        const credits = Math.round(total_pedagogical_hours / 9);
        return credits ? credits : 0;
      }
      return 0;
    },
    usesPucvCredits() {
      return this.$getInstitutionalCreditsFormula(this.institution) == "pucv";
    },
    // Asignatura cuyos créditos se editan: la base si usa sus valores, si no la del perfil.
    creditsMatter() {
      return this.matter.use_matter_values ? this.old_matter : this.matter;
    },
    pucvCredits() {
      return parseFloat(this.creditsMatter.institutional_credits) || 0;
    },
    pucvExpectedSct() {
      return pucvSctCredits(this.pucvCredits);
    },
    pucvWeeklyHours() {
      return pucvWeeklyHours(this.pucvCredits);
    },
    pucvMaxHours() {
      return pucvMaxSemesterHours(this.pucvCredits);
    },
    // Se compara en horas pedagógicas PUCV (35 min) y no con totalHours: este convierte
    // con los minutos del módulo y redondea, y la tabla DDCYF está en horas PUCV.
    pucvTotalHours() {
      if (!this.profileType) return 0;
      const hours = toPucvPedagogicalHours(
        this.totalPedagogical,
        this.totalChronological,
        this.profileType.module_minutes
      );
      return parseFloat(hours.toFixed(2));
    },
    // Solo alerta si se pasa; sin créditos ingresados no hay contra qué validar.
    pucvHoursExceeded() {
      return (
        this.usesPucvCredits &&
        this.pucvMaxHours > 0 &&
        this.pucvTotalHours > this.pucvMaxHours
      );
    },
    pucvSctMismatch() {
      return (
        this.usesPucvCredits &&
        !this.creditsMatter.use_automatic_credits &&
        parseFloat(this.creditsMatter.credits) != this.pucvExpectedSct
      );
    },
    // Textos en computeds separados para que cada uno se recalcule solo cuando cambia su valor.
    pucvCreditsLabel() {
      return this.$getVisibleNames(
        "manual.institutional_credits",
        false,
        "Créditos Institucionales"
      );
    },
    pucvCreditsReferenceText() {
      return this.$t("matterProgram.matterForm.pucvCreditsReference", {
        sct: this.pucvExpectedSct,
        weekly_hours: this.pucvWeeklyHours,
        hours: this.pucvMaxHours,
      });
    },
    pucvHoursExceededText() {
      return this.$t("matterProgram.matterForm.pucvHoursExceeded", {
        total: this.pucvTotalHours,
        max: this.pucvMaxHours,
        credits: this.pucvCredits,
        entity: this.pucvCreditsLabel,
      });
    },
    pucvSctMismatchText() {
      return this.$t("matterProgram.matterForm.pucvSctMismatch", {
        credits: this.pucvCredits,
        entity: this.pucvCreditsLabel,
        sct: this.pucvExpectedSct,
      });
    },
    pucvSctFormulaText() {
      return `${this.pucvCreditsLabel}(${this.pucvCredits}) × 1,5 = ${this.pucvExpectedSct}`;
    },
    filterEvaluationsByMatter() {
      // scope==3 para base_matter
      if (isNaN(this.old_matter.id)) return [];
      else
        return this.evaluations.filter(
          (x) => x.scope == 3 && x.scope_id == this.old_matter.id
        );
    },
    filterTestsByMatter() {
      const evaluations_ids = this.filterEvaluationsByMatter.map((x) => x.id);
      return this.tests.filter((x) => evaluations_ids.includes(x.evaluation));
    },
    theTestsHaveSomeErrors() {
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.institution.kl_assessment
      ) {
        if (
          this.filterTestsByMatter.some(
            (x) =>
              x.is_valid[0] == false ||
              (x.is_valid == true && x.manual_is_valid === false)
          ) ||
          this.filterTestsByMatter.length == 0
        )
          return true;
      }
      return false;
    },
    theTestsHaveSomeCorrect() {
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.institution.kl_assessment
      ) {
        if (
          this.filterTestsByMatter.some(
            (x) => x.is_valid == true && x.manual_is_valid == true
          )
        )
          return true;
      }
      return false;
    },
    theTestsNotYetClose() {
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.institution.kl_assessment
      ) {
        if (
          this.filterTestsByMatter.some(
            (x) => x.is_valid == true && x.manual_is_valid == false
          )
        )
          return true;
      }
      return false;
    },
    excludeECMicro() {
      const evaluation_criterio_micro_ids = [
        ...new Set(
          this.matters_evaluations
            .map((x) => x.evaluation_criterias_micro)
            .flat()
        ),
      ];
      return this.ECMicroFilterByStudyUnit.filter(
        (x) => !evaluation_criterio_micro_ids.includes(x.id)
      );
    },
    ECMicroFilterByStudyUnit() {
      const study_unit_ids = this.studyUnitsFilterByMatter.map((x) => x.id);
      return this.evaluationCriterias
        .filter((x) => study_unit_ids.includes(x.study_unit))
        .sort(function (a, b) {
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
    },
    studyUnitsFilterByMatter() {
      return this.studyUnits
        .filter((x) => x.matter == this.matter.matter)
        .sort(function (a, b) {
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
    },
  },
  methods: {
    confirmImportBaseMatter() {
      if (this.found_matter_id_by_code) {
        this.ChangeOldMatter(this.found_matter_id_by_code);
        this.verified_code = true;
        this.code_used = false;
      }
    },
    checkCode() {
      this.found_matter_id_by_code = null;
      if (this.old_matter && this.old_matter.code.trim() != "")
        this.$restful
          .Get(
            `/integrations/check_if_matter_code_exists/?matter_code=${
              this.old_matter.code
            }${
              !isNaN(this.old_matter.id)
                ? "&matter_id=" + this.old_matter.id
                : ""
            }`
          )
          .then((response) => {
            if (response == true) {
              this.verified_code = true;
              this.code_used = true;
              this.$restful
                .Get(
                  `/teaching/alt-matter/?search=${encodeURIComponent(
                    this.old_matter.code
                  )}`
                )
                .then((matter_response) => {
                  const results = matter_response.results || matter_response;
                  if (Array.isArray(results)) {
                    const match = results.find(
                      (m) => m.code === this.old_matter.code
                    );
                    if (match) {
                      this.found_matter_id_by_code = match.id;
                      this.found_matter_name_by_code = match.name;
                      this.$bvModal.show("bv-modal-import-base-matter");
                    }
                  }
                });
            } else if (response == false) {
              this.verified_code = true;
              this.code_used = false;
            }
          });
    },
    showOrHideAiModule() {
      if (
        this.matter &&
        !this.matter.is_closed &&
        this.old_matter &&
        !this.old_matter.is_closed
      )
        this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
      else this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
    },
    changeStateMatter() {
      if (!this.matter.is_closed) {
        // if (!this.theTestsHaveSomeErrors) {
        if (this.matter.competences.length == 0) {
          const modal = document.querySelector(".modal");
          if (modal) {
            modal.removeAttribute("aria-hidden");
          }
          this.$swal({
            title: this.$t("matterProgram.matterForm.sureToCloseEntity", {
              entity: this.$getVisibleNames(
                "mesh.egressprofilematter",
                false,
                "Asignatura"
              ),
            }),
            text: this.$t("matterProgram.matterForm.notAssignedAnyEntity", {
              entity: this.$getVisibleNames(
                "mesh.competence",
                false,
                "Competencia"
              ),
            }),
            type: "warning",
            confirmButtonText: this.$t("reusable.common.accept"),
            showCancelButton: true,
          }).then((result) => {
            if (result.value) {
              this.closeMatter();
            }
          });
        } else this.closeMatter();
        // }
      } else {
        this.$restful
          .Get(
            `/mesh/reopen_egress_profile_matter/?egress_profile_matter=${this.matter.id}`
          )
          .then(() => {
            this.matter.is_closed = !this.matter.is_closed;
            if (!isNaN(this.matter.id))
              this.$store
                .dispatch(names.FETCH_EGRESS_PROFILE_MATTER, this.matter.id)
                .then(() => {
                  this.showOrHideAiModule();
                });
          });
      }
    },
    closeMatter() {
      const payload = {
        egress_profile_matter_id: this.matter.id,
        item: { is_closed: !this.matter.is_closed },
      };
      this.$store
        .dispatch(names.PATCH_EGRESS_PROFILE_MATTER, payload)
        .then((response) => {
          this.matter.is_closed = response.is_closed;
          this.showOrHideAiModule();
        });
    },
    changeStateOldMatter() {
      // if (
      //   !this.theTestsHaveSomeErrors ||
      //   (this.old_matter && this.old_matter.is_closed)
      // ) {
      const payload = {
        matter_id: this.old_matter.id,
        item: {
          is_closed: !this.old_matter.is_closed,
        },
      };
      this.$store.dispatch(names.PATCH_MATTER, payload).then((response) => {
        this.old_matter.is_closed = response.is_closed;
        this.showOrHideAiModule();
      });
      // }
    },
    ChangeOldMatter(id) {
      if (isNaN(this.matter.id)) this.matter.prerequisites = [];
      this.$restful
        .Get(`/teaching/is_matter_transversal_and_prerequisites/?matter=${id}`)
        .then((response) => {
          if (response && response.is_matter_tranversal) {
            let matters_ids = response.default_prerequisite_objs.map(
              (x) => x.matter
            );
            let egress_profile_matters = this.egressProfilesMatters.filter(
              (x) => matters_ids.includes(x.matter)
            );
            if (
              egress_profile_matters.length != matters_ids.length &&
              (isNaN(this.matter.id) ||
                (!isNaN(this.matter.id) &&
                  this.matter.prerequisites.length == 0))
            ) {
              let ep_matters_ids = egress_profile_matters.map((x) => x.matter);
              let default_prerequisite_objs =
                response.default_prerequisite_objs.filter(
                  (x) => !ep_matters_ids.includes(x.matter)
                );
              const is_plural = default_prerequisite_objs.length > 1;
              this.$swal({
                html: this.$t(
                  "matterProgram.matterForm.assignPrerequisitesMessage",
                  {
                    entity1: this.$getVisibleNames(
                      "mesh.egressprofilematter",
                      false,
                      "Asignatura"
                    ),
                    plural1: is_plural ? "s" : "",
                    plural2: is_plural ? "s" : "",
                    entity2: this.$getVisibleNames(
                      "mesh.egressprofilematter",
                      is_plural ? true : false,
                      "Asignatura"
                    ),
                    matters: default_prerequisite_objs
                      .map((x) => x.code + " " + x.name)
                      .join(", "),
                  }
                ),
                type: "info",
                showCancelButton: false,
              });
            } else if (
              egress_profile_matters.length == matters_ids.length &&
              (isNaN(this.matter.id) ||
                (!isNaN(this.matter.id) &&
                  this.matter.prerequisites.length == 0))
            ) {
              this.matter.prerequisites = egress_profile_matters.map(
                (x) => x.id
              );
            }
          }
          if (
            this.faculty &&
            this.faculty.duoc_has_transversal_matters &&
            response &&
            response.is_matter_tranversal
          ) {
            this.show_err_trasnversal_matter = true;
          } else this.show_err_trasnversal_matter = false;
        });
      this.copyMatterToEgressProfileMatter(id);
      this.$bvModal.hide("bv-modal-matter-select");
    },
    copyMatterToEgressProfileMatter(matter_id) {
      this.matter.matter = matter_id;
      this.$store.dispatch(names.FETCH_MATTER, matter_id).then((response) => {
        if (response.is_closed) {
          this.verified_code = true;
          this.code_used = false;
        }
        this.old_matter = { ...response };
        // this.matter.formation_area = response.formation_area;
        this.matter.matter_types = response.matter_types;
        this.matter.modalities = response.modalities;
        this.matter.matter_contributions = response.matter_contributions;
        this.matter.study_environments = response.study_environments;
        this.matter.credits = response.credits;
        this.matter.institutional_credits = response.institutional_credits;
        this.matter.weeks = response.weeks;
        this.matter.toggle_in_weeks = response.toggle_in_weeks;
        this.matter.suggested_students = response.suggested_students;
        this.matter.suggested_teachers = response.suggested_teachers;
        this.matter.suggested_assistants = response.suggested_assistants;
        this.matter.use_automatic_credits = response.use_automatic_credits;
        this.matter.use_automatic_institutional_credits =
          response.use_automatic_institutional_credits;
        this.matter.is_exemptables = response.is_exemptable;
        this.$store
          .dispatch(names.FETCH_MATTER_TIME_ALLOCATIONS, {
            matter_id: matter_id,
          })
          .then((old_matter_hours_list) => {
            old_matter_hours_list.forEach((old_matter_hour) => {
              const index = this.matter_hours.findIndex(
                (matter_hour) =>
                  matter_hour.time_allocation == old_matter_hour.time_allocation
              );
              if (index != -1) {
                this.matter_hours[index].hours = old_matter_hour.hours;
                this.matter_hours[index].counts_towards_credits =
                  old_matter_hour.counts_towards_credits;
                this.matter_hours[index].attendance_requirement =
                  old_matter_hour.attendance_requirement;
                this.matter_hours[index].students_per_hour =
                  old_matter_hour.students_per_hour;
                this.matter_hours[index].tem_hours = Math.round(
                  parseFloat(
                    old_matter_hour.hours >= 0 ? old_matter_hour.hours : 0
                  ) / parseFloat(response.weeks)
                );
              }
              if (this.matter.use_matter_values) {
                this.reload_matter_time_allocation += 1;
              }
            });
          });
      });
    },
    filterCustom(row) {
      if (
        this.$filtered(row.name, this.input_search) ||
        this.$filtered(row.code, this.input_search) ||
        this.$filtered(
          this.getFormationArea(row.formation_area),
          this.input_search
        ) ||
        row.modalities.filter((x) =>
          this.$filtered(this.getModality(x), this.input_search)
        ).length > 0 ||
        this.$filtered(this.getRegime(row.regime), this.input_search)
      ) {
        return true;
      } else {
        return false;
      }
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    resetOldMatter() {
      this.old_matter.id = generateUniqueId();
      this.matter.matter = null;
      this.old_matter.code = "";
      this.old_matter.name = "";
      this.old_matter.automatic_achievement_weighing = true;
      this.old_matter.distribution_teaching_profile_hours = true;
      this.old_matter.learning_result_locked_view = true;
      this.old_matter.is_exemptable = false;
      this.show_err_trasnversal_matter = false;
      if (isNaN(this.matter.id)) this.matter.prerequisites = [];
    },
    slotCheckCredits() {
      if (!this.matter.use_matter_values) {
        this.matter.use_automatic_credits = !this.matter.use_automatic_credits;
        if (this.matter.use_automatic_credits == true) {
          this.matter.credits = this.creditSctChile;
        }
      } else {
        this.old_matter.use_automatic_credits =
          !this.old_matter.use_automatic_credits;
        if (
          this.old_matter.use_automatic_credits == true &&
          !this.old_matter.is_closed
        ) {
          this.old_matter.credits = this.creditSctChile;
        }
      }
    },
    slotCheckInstitutionalCredits() {
      if (!this.matter.use_matter_values) {
        this.matter.use_automatic_institutional_credits =
          !this.matter.use_automatic_institutional_credits;
        if (this.matter.use_automatic_institutional_credits == true) {
          this.matter.institutional_credits = this.institutionalCredits;
        }
      } else {
        this.old_matter.use_automatic_institutional_credits =
          !this.old_matter.use_automatic_institutional_credits;
        if (
          this.old_matter.use_automatic_institutional_credits == true &&
          !this.old_matter.is_closed
        ) {
          this.old_matter.institutional_credits = this.institutionalCredits;
        }
      }
    },
    dropdownShouldOpen(VueSelect) {
      if (this.formationLinesList.length > 0) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    dropdownShouldOpenMatterCategory(VueSelect) {
      if (this.matterCategories.length > 0) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    dropdownShouldOpen2(VueSelect) {
      if (this.studyEnvironments.length > 0) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.matter[name];
      return $dirty ? !$error : null;
    },
    validateOldMatter(name) {
      const { $dirty, $error } = this.$v.old_matter[name];
      return $dirty ? !$error : null;
    },
    changeLockedMatter(item) {
      if (!isNaN(this.old_matter.id) && this.isClosedOldMatterPartial) {
        this.$store
          .dispatch(names.PATCH_MATTER, {
            matter_id: this.old_matter.id,
            item: item,
          })
          .then((response) => {
            this.old_matter = response;
          });
      }
    },
    getRegime(regime_id) {
      if (!this.regimes) return `${this.$t("reusable.common.notApplicable")}`;
      const regime = this.regimes.find((x) => x.id == regime_id);
      return regime
        ? regime.name
        : `${this.$t("reusable.common.notApplicable")}`;
    },
    getModality(modality_id) {
      if (!this.modalities)
        return `${this.$t("reusable.common.notApplicable")}`;
      const modality = this.modalities.find((x) => x.id == modality_id);
      return modality
        ? modality.name
        : `${this.$t("reusable.common.notApplicable")}`;
    },
    getFormationArea(formation_area_id) {
      if (!this.formationAreas)
        return `${this.$t("reusable.common.notApplicable")}`;
      const formation_area = this.formationAreas.find(
        (x) => x.id == formation_area_id
      );
      return formation_area
        ? formation_area.name
        : `${this.$t("reusable.common.notApplicable")}`;
    },
    save() {
      // En PUCV el crédito institucional siempre se ingresa a mano (no hay toggle).
      if (this.usesPucvCredits) {
        this.matter.use_automatic_institutional_credits = false;
        this.old_matter.use_automatic_institutional_credits = false;
      }
      if (this.matter.use_matter_values) {
        this.matter.weeks = this.old_matter.weeks;
      } else {
        if (this.old_matter.weeks <= 0)
          this.old_matter.weeks = this.matter.weeks;
      }
      const profile_matters = this.egress_profiles_matters.filter(
        (x) =>
          x.matter == this.matter.matter &&
          x.egress_profile == this.matter.egress_profile
      );
      if (
        (profile_matters.length > 0 && isNaN(this.matter.id)) ||
        (profile_matters.length > 0 &&
          !profile_matters.find((matter) => matter.id == this.matter.id))
      ) {
        const course_wrapper = this.coursesWrappers.find((x) =>
          x.egress_profile_matters.includes(profile_matters[0].id)
        );
        if (course_wrapper) {
          return this.$swal({
            title: this.$t(
              "matterProgram.matterForm.alreadyHasEntityInProfile",
              {
                entity1: this.$getVisibleNames(
                  "mesh.egressprofile",
                  false,
                  "Perfil de Egreso"
                ),
                entity2: this.$getVisibleNames(
                  "mesh.egressprofilematter",
                  false,
                  "Asignatura"
                ),
                wrapper: course_wrapper.name,
              }
            ),
          });
        } else
          return this.$swal({
            title: this.$t(
              "matterProgram.matterForm.alreadyHasEntitySelected",
              {
                entity1: this.$getVisibleNames(
                  "mesh.egressprofile",
                  false,
                  "Perfil de Egreso"
                ),
                entity2: this.$getVisibleNames(
                  "mesh.egressprofilematter",
                  false,
                  "Asignatura"
                ),
              }
            ),
          });
      }

      this.$v.validationGroup.$touch();
      if (this.$v.validationGroup.$anyError) {
        return;
      }

      // Validar ambientes de estudio si aplica
      if (this.institution && this.institution.internal_use_id == "duoc.cl") {
        if (this.$refs.matterStudyEnvironmentOldMatter) {
          if (
            !this.$refs.matterStudyEnvironmentOldMatter.validateAllEnvironments()
          ) {
            return;
          }
        }

        if (this.$refs.matterStudyEnvironmentMatter) {
          if (
            !this.$refs.matterStudyEnvironmentMatter.validateAllEnvironments()
          ) {
            return;
          }
        }
      }

      this.saving = true;
      this.disabled_component_hours_in_save = false;
      if (this.matter.use_matter_values) {
        if (isNaN(this.old_matter.id)) {
          const payload = {
            name: this.old_matter.name,
            code: this.old_matter.code,
            is_elective: this.old_matter.is_elective,
            is_capstone_course: this.old_matter.is_capstone_course,
            formation_area: this.matter.formation_area,
            modalities: this.old_matter.modalities,
            // Si el tipo se edita en el perfil (PUCV), la asignatura base nace con ese.
            matter_types: this.editsEgressProfileMatterTypes
              ? this.matter.matter_types
              : this.old_matter.matter_types,
            matter_contributions: this.matter.matter_contributions,
            evaluation_instruments: this.matter.evaluation_instruments,
            study_environments: this.old_matter.study_environments,
            methodological_strategies: [],
            weeks: this.old_matter.weeks,
            credits: this.old_matter.credits,
            institutional_credits: this.old_matter.institutional_credits,
            suggested_students: this.old_matter.suggested_students,
            suggested_teachers: this.old_matter.suggested_teachers,
            suggested_assistants: this.old_matter.suggested_assistants,
            matter_category: this.old_matter.matter_category,
            default_language: this.old_matter.default_language,
            publish_date: this.old_matter.publish_date,
            automatic_achievement_weighing:
              this.old_matter.automatic_achievement_weighing,
            toggle_in_weeks: this.old_matter.toggle_in_weeks,
            is_exemptable: this.old_matter.is_exemptable,
            use_automatic_credits: this.old_matter.use_automatic_credits,
            distribution_teaching_profile_hours:
              this.old_matter.distribution_teaching_profile_hours,
            learning_result_locked_view:
              this.old_matter.learning_result_locked_view,
            use_automatic_institutional_credits:
              this.old_matter.use_automatic_institutional_credits,
          };
          this.$store.dispatch(names.POST_MATTER, payload).then((response) => {
            this.matter.matter = response.id;
            this.old_matter.id = response.id;
            if (isNaN(this.matter.id)) this.create();
            else this.update();
          });
        } else {
          const payload = {
            matter_id: this.old_matter.id,
            item: {
              name: this.old_matter.name,
              code: this.old_matter.code,
              is_elective: this.old_matter.is_elective,
              is_capstone_course: this.old_matter.is_capstone_course,
              // formation_area: this.matter.formation_area,
              modalities: this.old_matter.modalities,
              matter_types: this.old_matter.matter_types,
              // matter_contributions: this.matter.matter_contributions,
              study_environments: this.old_matter.study_environments,
              weeks: this.old_matter.weeks,
              credits: this.old_matter.credits,
              institutional_credits: this.old_matter.institutional_credits,
              suggested_students: this.old_matter.suggested_students,
              suggested_teachers: this.old_matter.suggested_teachers,
              suggested_assistants: this.old_matter.suggested_assistants,
              matter_category: this.old_matter.matter_category,
              default_language: this.old_matter.default_language,
              publish_date: this.old_matter.publish_date,
              automatic_achievement_weighing:
                this.old_matter.automatic_achievement_weighing,
              toggle_in_weeks: this.old_matter.toggle_in_weeks,
              is_exemptable: this.old_matter.is_exemptable,
              use_automatic_credits: this.old_matter.use_automatic_credits,
              distribution_teaching_profile_hours:
                this.old_matter.distribution_teaching_profile_hours,
              learning_result_locked_view:
                this.old_matter.learning_result_locked_view,
              use_automatic_institutional_credits:
                this.old_matter.use_automatic_institutional_credits,
            },
          };
          this.$store.dispatch(names.PATCH_MATTER, payload).then((response) => {
            this.old_matter = { ...response };
            this.matter.matter = response.id;
            if (!isNaN(this.matter.matter) && this.matter.matter != null) {
              if (isNaN(this.matter.id)) this.create();
              else this.update();
            }
          });
        }
      } else {
        // !this.matter.use_matter_values
        if (isNaN(this.old_matter.id)) {
          const payload = {
            name: this.old_matter.name,
            code: this.old_matter.code,
            is_elective: this.old_matter.is_elective,
            is_capstone_course: this.old_matter.is_capstone_course,
            formation_area: this.matter.formation_area,
            modalities: this.matter.modalities,
            matter_types: this.matter.matter_types,
            matter_contributions: this.matter.matter_contributions,
            evaluation_instruments: this.matter.evaluation_instruments,
            study_environments: this.matter.study_environments,
            methodological_strategies: [],
            weeks: this.matter.weeks,
            credits: this.matter.credits,
            institutional_credits: this.matter.institutional_credits,
            suggested_students: this.matter.suggested_students,
            suggested_teachers: this.matter.suggested_teachers,
            suggested_assistants: this.matter.suggested_assistants,
            publish_date: this.old_matter.publish_date,
            matter_category: this.old_matter.matter_category,
            default_language: this.old_matter.default_language,
            automatic_achievement_weighing:
              this.old_matter.automatic_achievement_weighing,
            toggle_in_weeks: this.matter.toggle_in_weeks,
            use_automatic_credits: this.matter.use_automatic_credits,
            distribution_teaching_profile_hours:
              this.old_matter.distribution_teaching_profile_hours,
            learning_result_locked_view:
              this.old_matter.learning_result_locked_view,
            use_automatic_institutional_credits:
              this.matter.use_automatic_institutional_credits,
            is_exemptable: this.matter.is_exemptable,
          };
          this.$store.dispatch(names.POST_MATTER, payload).then((response) => {
            this.matter.matter = response.id;
            this.old_matter.id = response.id;
            if (isNaN(this.matter.id)) this.create();
            else this.update();
          });
        } else {
          const payload = {
            matter_id: this.old_matter.id,
            item: {
              name: this.old_matter.name,
              code: this.old_matter.code,
              is_elective: this.old_matter.is_elective,
              is_capstone_course: this.old_matter.is_capstone_course,
              default_language: this.old_matter.default_language,
              automatic_achievement_weighing:
                this.old_matter.automatic_achievement_weighing,
              distribution_teaching_profile_hours:
                this.old_matter.distribution_teaching_profile_hours,
              learning_result_locked_view:
                this.old_matter.learning_result_locked_view,
            },
          };
          this.$store.dispatch(names.PATCH_MATTER, payload).then((response) => {
            this.old_matter = { ...response };
            this.matter.matter = response.id;
            if (!isNaN(this.matter.matter) && this.matter.matter != null) {
              if (isNaN(this.matter.id)) this.create();
              else this.update();
            }
          });
        }
      }
    },
    askForDeleteMatter() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.egressprofilematter",
            false,
            "Asignatura"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) this.deleteMatter();
      });
    },
    create() {
      this.matter.campuses = this.egress_profiles.find(
        (x) => x.id == this.egress_profile_id
      ).campuses;
      if (!this.allow_crud) {
        this.saving = false;
        this.$emit("create", this.matter);
        return;
      }
      this.$store
        .dispatch(names.POST_EGRESS_PROFILE_MATTER, this.matter)
        .then((response) => {
          this.matter = response;
          if (this.courses_wrapper_id && this.courses_wrapper_id != null) {
            let payload = this.coursesWrapper;
            payload.egress_profile_matters.push(response.id);
            this.$store.dispatch(names.UPDATE_COURSE_WRAPPER, payload);
          }
          this.$restful.Get(
            `mesh/copy_egress_profile_matter_descriptors/?original_matter=${response.matter}&target_epm=${response.id}`
          );
          this.$restful
            .Get(
              `teaching/toggle_matter_automatic_achievement_weighing/?matter=${response.matter}`
            )
            .then(() => {
              this.fetchInitEvaluations(response.matter);
              this.$store.dispatch(
                names.FETCH_EVALUATION_CRITERIAS_MACROS,
                response.matter
              );
              this.$store.dispatch(names.FETCH_STUDY_UNITS, response.matter);
              this.$store.dispatch(names.FETCH_COMPETENCE_UNITS, {
                matter__id: response.matter,
                force: true,
              });
            });
          if (!this.matters.find((x) => x.id == response.matter)) {
            this.$store
              .dispatch(names.FETCH_MATTER, response.matter)
              .then((matter) => {
                this.old_matter = matter;
              });
          } else {
            const old_matter = this.matters.find(
              (x) => x.id == response.matter
            );
            if (old_matter) this.old_matter = old_matter;
          }
          // if (
          //   (this.institution && this.institution.internal_use_id == 'duoc.cl')
          // )
          this.$nextTick(() => {
            this.tab_index = 1;
          });
          // else this.$emit("created", response);
          if (this.matter.use_matter_values) this.saveOldMatterHours(response);
          else this.saveMatterHours(response.id);
          this.saveStudyEnvironments();
          toast(
            this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "Asignatura"
            ) +
              " " +
              this.$t("reusable.common.created") +
              "."
          );
          this.saving = false;
        });
    },
    update() {
      this.matter.campuses = this.egress_profiles.find(
        (x) => x.id == this.egress_profile_id
      ).campuses;
      if (!this.allow_crud) {
        this.saving = false;
        this.$emit("update", this.matter);
        return;
      }
      if (!this.matter.is_closed) {
        const payload = {
          egress_profile_matter_id: this.matter.id,
          item: {
            id: this.matter.id,
            order: this.matter.order,
            plan_level: this.matter.plan_level,
            toggle_in_weeks: this.matter.toggle_in_weeks,
            study_environments: this.matter.study_environments,
            suggested_students: this.matter.suggested_students,
            suggested_teachers: this.matter.suggested_teachers,
            suggested_assistants: this.matter.suggested_assistants,
            regime: this.matter.regime,
            is_integrative: this.matter.is_integrative,
            is_exemptable: this.matter.is_exemptable,
            formation_area: this.matter.formation_area,
            matter: this.matter.matter,
            formation_line: this.matter.formation_line,
            matter_types: this.matter.matter_types,
            matter_contributions: this.matter.matter_contributions,
            modalities: this.matter.modalities,
            egress_profile: this.matter.egress_profile,
            campuses: this.matter.campuses,
            weeks: this.matter.weeks,
            credits: this.matter.credits,
            institutional_credits: this.matter.institutional_credits,
            use_automatic_credits: this.matter.use_automatic_credits,
            use_automatic_institutional_credits:
              this.matter.use_automatic_institutional_credits,
            use_matter_values: this.matter.use_matter_values,
            code: this.matter.code,
          },
        };
        this.$store
          .dispatch(names.PATCH_EGRESS_PROFILE_MATTER, payload)
          .then((response) => {
            this.$restful
              .Get(
                `teaching/toggle_matter_automatic_achievement_weighing/?matter=${response.matter}`
              )
              .then(() => {
                this.fetchInitEvaluations(response.matter);
                this.$store.dispatch(
                  names.FETCH_EVALUATION_CRITERIAS_MACROS,
                  response.matter
                );
                this.$store.dispatch(names.FETCH_STUDY_UNITS, response.matter);
                this.$store.dispatch(names.FETCH_COMPETENCE_UNITS, {
                  matter__id: response.matter,
                  force: true,
                });
              });
            if (!isNaN(this.matter.id) && !this.Matter) {
              this.$emit("close_modal", response);
            }
            this.$emit("updated", response);
            if (this.matter.use_matter_values)
              this.saveOldMatterHours(response);
            else this.saveMatterHours(response.id);
            this.saveStudyEnvironments();
            if (!this.matters.find((x) => x.id == response.matter))
              this.$store.dispatch(names.FETCH_MATTER, response.matter);
            toast(
              this.$getVisibleNames(
                "mesh.egressprofilematter",
                false,
                "Asignatura"
              ) +
                " " +
                this.$t("reusable.common.updated") +
                "."
            );
            this.saving = false;
          });
      } else {
        this.$restful
          .Get(
            `teaching/toggle_matter_automatic_achievement_weighing/?matter=${this.matter.matter}`
          )
          .then(() => {
            this.fetchInitEvaluations(this.matter.matter);
            this.$store.dispatch(
              names.FETCH_EVALUATION_CRITERIAS_MACROS,
              this.matter.matter
            );
            this.$store.dispatch(names.FETCH_STUDY_UNITS, this.matter.matter);
            this.$store.dispatch(names.FETCH_COMPETENCE_UNITS, {
              matter__id: this.matter.matter,
              force: true,
            });
          });
        if (!isNaN(this.matter.id) && !this.Matter) {
          this.$emit("close_modal", this.matter);
        }
        this.$emit("updated", this.matter);
        if (this.matter.use_matter_values) this.saveOldMatterHours(this.matter);
        else this.saveMatterHours(this.matter.id);
        this.saveStudyEnvironments();
        if (!this.matters.find((x) => x.id == this.matter.matter))
          this.$store.dispatch(names.FETCH_MATTER, this.matter.matter);
        toast(
          this.$getVisibleNames(
            "mesh.egressprofilematter",
            false,
            "Asignatura"
          ) +
            " " +
            this.$t("reusable.common.updated") +
            "."
        );
        this.saving = false;
      }
    },
    async saveStudyEnvironments() {
      // Solo guardar si estamos en la primera tab (tab_index === 0)
      // Esto evita que se intente guardar nuevamente cuando cambiamos de tab
      if (this.tab_index !== 0) {
        return;
      }

      if (this.institution && this.institution.internal_use_id === "duoc.cl") {
        if (this.$refs.matterStudyEnvironmentOldMatter) {
          await this.$refs.matterStudyEnvironmentOldMatter.saveStudyEnvironments();
        }
        if (this.$refs.matterStudyEnvironmentMatter) {
          await this.$refs.matterStudyEnvironmentMatter.saveStudyEnvironments();
        }
      }
    },
    slotUpdateMatterHours(matter_hours) {
      this.matter_hours = matter_hours;
    },
    // slotUpdateOldMatter(oldMatter) {
    //   this.old_matter = oldMatter;
    // },
    slotUpdateOldMatterHours(old_matter_hours) {
      this.old_matter_hours = old_matter_hours;
    },
    async saveMatterHours(egress_profile_matter_id) {
      // Evita que un doble clic en Guardar dispare dos POST en paralelo
      // para la misma hora recién creada (aún sin id real) y choque con
      // el unique_together (egress_profile_matter, time_allocation) del backend.
      if (this.saving_matter_hours) return;
      this.saving_matter_hours = true;
      try {
        for await (let hour of this.matter_hours) {
          if (isNaN(hour.id)) {
            hour.egress_profile_matter = egress_profile_matter_id;
            await this.$store
              .dispatch(names.POST_EP_MATTER_TIME_ALLOCATION, hour)
              .then((response) => {
                hour.id = response.id;
              });
          } else {
            hour.egress_profile_matter = egress_profile_matter_id;
            await this.$store.dispatch(
              names.UPDATE_EP_MATTER_TIME_ALLOCATION,
              hour
            );
          }
        }
        if (this.institution && this.institution.uses_ipss_assessment == true)
          this.$restful.Get(
            `/mesh/update_ipss_egress_profile_matter_evaluatee_assessments/?egress_profile_matter=${egress_profile_matter_id}`
          );
        this.disabled_component_hours_in_save = true;
      } finally {
        this.saving_matter_hours = false;
      }
    },
    async saveOldMatterHours(matter) {
      // Misma guardia que saveMatterHours, para el mismo caso con Asignaturas Base.
      if (this.saving_old_matter_hours) return;
      this.saving_old_matter_hours = true;
      try {
        for await (let hour of this.old_matter_hours) {
          if (isNaN(hour.id)) {
            hour.matter = matter.matter;
            await this.$store
              .dispatch(names.POST_MATTER_TIME_ALLOCATION, hour)
              .then((response) => {
                hour.id = response.id;
              });
          } else {
            hour.matter = matter.matter;
            await this.$store.dispatch(
              names.UPDATE_MATTER_TIME_ALLOCATION,
              hour
            );
          }
        }
        if (this.institution && this.institution.uses_ipss_assessment == true)
          this.$restful.Get(
            `/mesh/update_ipss_egress_profile_matter_evaluatee_assessments/?egress_profile_matter=${matter.id}`
          );
        this.disabled_component_hours_in_save = true;
      } finally {
        this.saving_old_matter_hours = false;
      }
    },
    deleteMatter() {
      if (!this.allow_crud) {
        this.$emit("delete", this.matter);
        return;
      }
      this.$store
        .dispatch(names.DELETE_EGRESS_PROFILE_MATTER, this.matter.id)
        .then(() => {
          this.$emit("deleted", this.matter);
          toast(
            this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "Asignatura"
            ) +
              " " +
              this.$t("reusable.common.deleted") +
              "."
          );
        });
    },
    openModalFormationLine(is_created = true) {
      if (this.faculties.length == 0)
        this.$store.dispatch(names.FETCH_FACULTIES);
      if (is_created) this.$bvModal.show(`new-formation-line-modal`);
      else if (this.matter.formation_line != null)
        this.$bvModal.show(
          `edit-formation-line-modal-${this.matter.formation_line}`
        );
    },
    slotCreatedFormationLine(respone) {
      this.matter.formation_line = respone.id;
      this.$bvModal.hide("new-formation-line-modal");
    },
    fetchInitEvaluations(matter_id) {
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.institution.kl_assessment
      ) {
        // scoped_id:3 para base_matter
        this.$store
          .dispatch(names.FETCH_NEW_EVALUATIONS, {
            scoped_id: 3,
            scoped_object_id: matter_id,
          })
          .then((evaluations) => {
            this.$store.dispatch(names.FETCH_NEW_TESTS, {
              evaluations_ids: evaluations.map((x) => x.id),
            });
          });
      }
    },
    fetchMattersEvaluation() {
      if (this.matter && this.matter.matter)
        this.$restful
          .GetAll(`/teaching/matter-evaluation/?matter=${this.matter.matter}`)
          .then((response) => {
            this.matters_evaluations = response.sort(function (a, b) {
              if (a.order > b.order) return 1;
              if (a.order < b.order) return -1;
              return 0;
            });
          });
    },
  },
  created() {
    this.$store.dispatch(names.FETCH_LANGUAGES);
    this.fetchMattersEvaluation();
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id)
      .then((response) => {
        this.$store
          .dispatch(names.FETCH_CAREER, response.career)
          .then((career) => {
            this.$store.dispatch(names.FETCH_FACULTY, career.faculty);
          });
      });
    this.$store.dispatch(names.FETCH_MATTER_CATEGORIES);
    this.$store.dispatch(names.FETCH_PROFILE_TYPES);
    this.$store.dispatch(names.FETCH_CAMPUSES);
    this.$store.dispatch(names.FETCH_REGIMES);
    this.$store.dispatch(names.FETCH_FORMATION_AREAS);
    this.$store.dispatch(names.FETCH_MODALITIES);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS_TIME_ALLOCATION);
    this.$store.dispatch(names.FETCH_MATTER_CODES).then((response) => {
      this.matter_codes = response;
    });
    if (!isNaN(this.old_matter.id)) {
      this.$store
        .dispatch(names.FETCH_MATTER, this.old_matter.id)
        .then((response) => {
          this.old_matter = { ...response };
          this.old_matter.name = this.old_matter.name.toUpperCase();
          this.step_matter = true;
        });
    } else this.step_matter = true;
  },
  watch: {
    matter: {
      handler() {
        if (
          isNaN(this.matter.id) &&
          this.finished_mounted &&
          !this.matter.use_matter_values
        ) {
          this.$emit("change_matter_form");
        }
      },
      deep: true,
    },
    old_matter: {
      handler() {
        if (this.old_matter.default_language == null && this.institution) {
          this.old_matter.default_language = this.institution.default_language;
        }
        if (
          isNaN(this.old_matter.id) &&
          this.finished_mounted &&
          this.matter.use_matter_values
        ) {
          this.$emit("change_matter_form");
        }
        // Se agrego la condición de la institución dado que el is_valid tiene una estructura particular.
        if (
          !isNaN(this.old_matter.id) &&
          this.institution &&
          this.institution.internal_use_id == "duoc.cl"
        )
          this.fetchInitEvaluations(this.old_matter.id);
      },
      deep: true,
    },
    creditSctChile() {
      if (!this.matter.use_matter_values) {
        if (this.matter.use_automatic_credits == true)
          this.matter.credits = this.creditSctChile;
      } else {
        if (
          this.old_matter.use_automatic_credits == true &&
          !this.old_matter.is_closed
        )
          this.old_matter.credits = this.creditSctChile;
      }
    },
    institutionalCredits() {
      // En PUCV no hay cálculo automático: no pisar el crédito ingresado a mano.
      if (this.usesPucvCredits) return;
      if (!this.matter.use_matter_values) {
        if (this.matter.use_automatic_institutional_credits == true)
          this.matter.institutional_credits = this.institutionalCredits;
      } else {
        if (
          this.old_matter.use_automatic_institutional_credits == true &&
          !this.old_matter.is_closed
        )
          this.old_matter.institutional_credits = this.institutionalCredits;
      }
    },
  },
  mounted() {
    if (isNaN(this.matter.id)) this.matter.order = this.orderSugested;
    if (this.matter.weeks == 0) {
      if (this.profileType) {
        if (
          this.$equals(this.profileType.name, "Pregrado") &&
          this.institution &&
          this.institution.actual_period &&
          this.institution.actual_period.weeks > 0
        ) {
          this.matter.weeks = this.institution.actual_period.weeks;
        }
      }
    }

    setInterval(() => {
      this.finished_mounted = true;
      clearInterval();
    }, 500);
  },
};
</script>

<style scoped>
.btn-close-matter {
  justify-content: right;
  align-items: center;
  display: flex;
}
.size-info-tooltip {
  height: 20px !important;
  width: 20px !important;
}
.btn-name-matter {
  width: 31px;
  height: 31px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-check-code {
  width: 31px;
  height: 31px;
  padding: 0px;
}
.unlock-icon-off {
  display: none;
}
.btn-unlock {
  padding: 3px;
  color: #007bff !important;
}
.btn-unlock:hover {
  color: #4894f8 !important;
}
.btn-add {
  border: none;
  background: transparent;
  font-size: 13pt;
  padding: 0;
  margin-left: 0.7rem;
}
.toggle-types {
  display: flex;
  float: right;
  /* margin-right: 1em; */
  /* background: rgb(230, 230, 230); */
  padding: 0.3em 1.8em;
  border-radius: 3px;
}
.check-type {
  background: #007bff !important;
  margin-inline: 0.7em;
  height: 1.12em;
  width: 2.2em !important;
  margin-top: 2%;
  border-radius: 10px;
}
.check-type-disabled {
  background: #6c757d !important;
  border: 1px solid #6c757d;
  margin-inline: 0.7em;
  height: 1.12em;
  width: 2.2em !important;
  margin-top: 2%;
  border-radius: 10px;
}
.matter-name {
  border: 1px solid #17a2b8;
}
.icon-check {
  color: white;
  transform: translate(-69%, -50%);
  transition: 0.2s;
}
.icon-check-disabled {
  color: rgb(190, 190, 190) !important;
}
.icon-check-active {
  transform: translate(15%, -50%) !important;
}
.visible {
  visibility: visible;
  opacity: 1;
  transition: opacity 2s linear;
}
#input-order {
  margin-top: 0.8rem;
  margin-bottom: 0.2rem;
}
#input-total-class-hours,
#input-total-autonomous-hours {
  border: 1px solid #ced4da;
  transition: border-width 0.3s linear;
  -webkit-transition: border-color 0.3s ease-out;
  -moz-transition: border-color 0.3s ease-out;
  -o-transition: border-color 0.3s ease-out;
  -ms-transition: border-color 0.3s ease-out;
  transition: border-color 0.3s ease-out;
}
#input-module-class-hours {
  font-size: var(--primary-font-size);
}
.highlight-input {
  border: solid var(--primary-color) !important;
  border-width: 3px;
  transition: border 0.4s ease-out;
}
.select-base-matter-banner {
  border: 1.5px solid #bee5eb;
  border-left: 4px solid var(--primary-color, #007bff);
}
.select-base-matter-banner-content {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}
.select-base-matter-banner-text {
  flex: 1;
  min-width: 180px;
  font-size: var(--primary-font-size);
}
.select-base-matter-banner-text strong {
  display: block;
  margin-bottom: 0.15rem;
}
.select-base-matter-banner-desc {
  display: block;
  font-size: 0.8rem;
}
.btn-select-default,
.btn-clear-inputs {
  border: none;
  background: transparent;
  font-size: 11pt;
  padding: 0;
  margin-left: 0.7rem;
}
.btn-clear-inputs {
  font-size: 10pt;
}

#total_hours {
  margin-left: 0.6rem;
}
#credit {
  /* margin-left: 0.2rem; */
  max-height: 2.3rem;
}

#credit,
#total_hours,
#learning_result_locked_view,
#distribution_teaching_profile_hours {
  font-size: var(--primary-font-size);
}
textarea {
  width: 100%;
}

.form-group >>> .col-form-label {
  font-size: var(--secondary-font-size) !important;
}
.label {
  /* font-size: var(--thirth-font-size); */
  font-size: var(--secondary-font-size);
  /* margin-bottom: -1% !important; */
}
.form-group >>> .label-matter {
  margin-top: 0.2rem;
  padding-right: 10px !important;
  font-size: var(--secondary-font-size);
}
.custom-input {
  margin-bottom: -3.4% !important;
}
.custom-row {
  display: flex;
  margin-top: -2.4% !important;
  margin-bottom: -2.4% !important;
  width: 100%;
}
.row-code {
  display: flex;
  min-height: 3rem;
  width: 100% !important;
  /* margin-bottom: -1.6% !important; */
  margin-top: 0;
}
.label-code {
  font-size: var(--secondary-font-size);
  margin-top: 3.5% !important;
  margin-left: 0.4em;
}
.input-code {
  width: 99%;
  margin-left: 0.5%;
  transform: translateY(-10%);
}

#input-code-live-feedback {
  margin-top: -1.4%;
  margin-left: 1%;
}

.total-modules {
  margin-top: 0 !important;
}

/* .input-modality {
  font-size: 0.875rem !important;
} */
.v-select >>> .vs__search,
.v-select >>> .vs__search:focus,
.v-select >>> .vs__selected {
  font-size: 0.875rem !important;
  color: #495057 !important;
}

.v-select >>> .vs__clear {
  margin-bottom: 0.2rem !important;
}
.total-modules-value {
  font-weight: normal;
}

.total-hours-value {
  min-width: 60px;
  margin-left: 0.1em !important;
  font-weight: normal;
}
.pucv-credits-alert {
  padding: 0.35rem 0.75rem;
  margin-bottom: 0.5rem;
  font-size: var(--secondary-font-size);
  text-align: left;
}
.credits-value {
  margin-left: 0.1em;
  font-size: var(--primary-font-size) !important;
  font-weight: normal;
  line-height: 1;
  min-width: 60px;
  max-height: 1.5rem;
  margin-top: 0.2rem;
}

.weighing-label,
.total-modules-label {
  display: flex;
}
.weighing-info::after,
.total-modules-label::after {
  vertical-align: top;
}
.label-content {
  width: max-content;
}
.info-icon {
  position: relative;
  vertical-align: top;
  height: 12px;
  width: 12px;
}
.total-modules-label > .label-content {
  max-width: 7rem;
}
.link-modal-evaluations {
  text-decoration: underline; /* Aplica subrayado */
  cursor: pointer; /* Cambia el puntero a una mano */
  color: #0000ee; /* Color azul típico de los enlaces */
}
.link-modal-evaluations:hover {
  font-weight: bold; /* Aplica negrita al hacer hover */
  color: #551a8b; /* Cambia el color al hacer hover, a un morado oscuro similar al de los enlaces visitados */
}
@media (max-width: 991px) {
  .info-icon {
    margin-left: 0;
  }
}
</style>